// This file is auto-generated by @hey-api/openapi-ts

import { type InfiniteData, infiniteQueryOptions, queryOptions, type UseMutationOptions } from '@tanstack/react-query';

import { client } from '../client.gen';
import { adminCreateInvitation, adminDeleteFeedback, adminFeedbackSummary, adminGetFeedback, adminGetFeedbackScreenshot, adminGetSettings, adminGetUser, adminListAuthEvents, adminListFeedback, adminListInvitations, adminListSettingsHistory, adminListUsers, adminResendInvitation, adminResetUserMfa, adminRevokeInvitation, adminRevokeUserSessions, adminSendPasswordReset, adminSetAssistantBudget, adminUpdateFeedback, adminUpdateSettings, adminUpdateUser, assessmentsApproveAssessment, assessmentsCreateAssessment, assessmentsDeleteAssessment, assessmentsEstimateAssessment, assessmentsExportAssessmentXlsx, assessmentsGetAssessment, assessmentsGetTopicResult, assessmentsGetVersionImpact, assessmentsListAssessments, assessmentsListTopicResults, assessmentsReopenAssessment, assessmentsRerunAssessment, assessmentsReviewTopicResult, assistantDeleteThread, assistantDeleteThreads, assistantGetBudget, assistantGetThread, assistantListSuggestions, assistantListThreads, assistantRenameThread, authAcceptInvitation, authChangePassword, authCompleteSignIn, authConfirmAuthenticatorReplacement, authConfirmPasswordReset, authConfirmSetup, authGetAuthOptions, authGetPasswordPolicy, authListSessions, authLookUpInvitation, authLookUpPasswordReset, authRequestPasswordReset, authRevokeOtherSessions, authRevokeSession, authSignIn, authSignOut, authStartAuthenticatorReplacement, authStartSetup, capabilitiesCompleteCapabilityUpload, capabilitiesCreateCapabilityUpload, capabilitiesDeleteCapabilityDocument, capabilitiesDeleteCapabilityUpload, capabilitiesExtractCapabilityDocument, capabilitiesGetCapabilityDocument, capabilitiesGetCapabilityDocumentPdf, capabilitiesGetCapabilityUpload, capabilitiesListCapabilities, capabilitiesListCapabilityDocuments, capabilitiesPutCapabilityUploadPart, catalogGetCurrentDocument, catalogGetDocument, catalogGetDocumentStats, catalogGetTable, catalogListAuthorities, catalogListDocuments, catalogListFamilies, catalogListFigures, catalogListStandards, catalogListTables, catalogListThresholds, clausesGetClause, clausesGetToc, clausesListClauses, clausesListPageClauses, curvesGetChart, curvesGetCurve, curvesGetCurveFacets, curvesListBands, curvesListCharts, curvesListCurves, datasetsGetDatasetPreview, datasetsGetDatasetsOverview, datasetsGetDocumentContents, datasetsListDatasets, exportsExportRequirementsCsv, exportsExportRequirementsXlsx, feedbackSendFeedback, jobsCancelJob, jobsCreateJob, jobsGetActiveJobCount, jobsGetJob, jobsGetJobCapacity, jobsGetJobEstimate, jobsGetRollbackImpact, jobsListJobs, lifecycleGetClauseContextDiff, lifecycleGetVersionDiff, lifecycleListFamilyVersions, lifecyclePromoteDocument, lifecycleSetDocumentStatus, metaGetHealth, metaGetMe, metaGetMeta, metaGetReadiness, metaListJurisdictions, operationsGetConfidenceHistogram, operationsGetDocumentAudit, operationsGetDocumentIntegrity, operationsGetRun, operationsGetRunReport, operationsGetSourceWatch, operationsGetSystemStatus, operationsListActivity, operationsListCompletenessGaps, operationsListEvaluations, operationsListRuns, operationsListSources, type Options, registryCreateRegistryAuthority, registryCreateRegistryFamily, registryCreateRegistryJurisdiction, registryCreateRegistryVersion, registryExportSourceRegistry, registryGetRegistryAuthority, registryGetRegistryFamily, registryGetRegistryJurisdiction, registryGetRegistrySummary, registryGetRegistryVersion, registryListDatasetEvents, registryListRegistryAuthorities, registryListRegistryFamilies, registryListRegistryJurisdictions, registryListRegistryRevisions, registryListSourceAdapters, registryListSupportedLanguages, registryReplaceFamilySections, registryRetireRegistryAuthority, registryRetireRegistryFamily, registryRetireRegistryJurisdiction, registryRetireRegistryVersion, registryUpdateRegistryAuthority, registryUpdateRegistryFamily, registryUpdateRegistryJurisdiction, registryUpdateRegistryVersion, registryVerifyDatasetEvents, requirementsGetRequirement, requirementsGetRequirementFacets, requirementsListRequirements, searchGetOmnibox, searchSearchClauses, sourcesGetDocumentPdf, sourcesGetFigureImage, sourcesGetPageHighlights, sourcesLocateTexts, uploadsCompleteUpload, uploadsCreateUpload, uploadsDeleteUpload, uploadsGetSourceFile, uploadsGetSourceFilePdf, uploadsGetSourceProfile, uploadsGetUpload, uploadsListSourceFiles, uploadsPutUploadPart, vocabularyGetDefinition, vocabularyGetParameter, vocabularyListDefinitions, vocabularyListParameterGroups, vocabularyListParameterMarkets, vocabularyListParameters, vocabularyLookupDefinition, whatsNewListEntries, whatsNewMarkSeen } from '../sdk.gen';
import type { AdminCreateInvitationData, AdminCreateInvitationError, AdminCreateInvitationResponse, AdminDeleteFeedbackData, AdminDeleteFeedbackError, AdminDeleteFeedbackResponse, AdminFeedbackSummaryData, AdminFeedbackSummaryError, AdminFeedbackSummaryResponse, AdminGetFeedbackData, AdminGetFeedbackError, AdminGetFeedbackResponse, AdminGetFeedbackScreenshotData, AdminGetFeedbackScreenshotError, AdminGetFeedbackScreenshotResponse, AdminGetSettingsData, AdminGetSettingsError, AdminGetSettingsResponse, AdminGetUserData, AdminGetUserError, AdminGetUserResponse, AdminListAuthEventsData, AdminListAuthEventsError, AdminListAuthEventsResponse, AdminListFeedbackData, AdminListFeedbackError, AdminListFeedbackResponse, AdminListInvitationsData, AdminListInvitationsError, AdminListInvitationsResponse, AdminListSettingsHistoryData, AdminListSettingsHistoryError, AdminListSettingsHistoryResponse, AdminListUsersData, AdminListUsersError, AdminListUsersResponse, AdminResendInvitationData, AdminResendInvitationError, AdminResendInvitationResponse, AdminResetUserMfaData, AdminResetUserMfaError, AdminResetUserMfaResponse, AdminRevokeInvitationData, AdminRevokeInvitationError, AdminRevokeInvitationResponse, AdminRevokeUserSessionsData, AdminRevokeUserSessionsError, AdminRevokeUserSessionsResponse, AdminSendPasswordResetData, AdminSendPasswordResetError, AdminSendPasswordResetResponse, AdminSetAssistantBudgetData, AdminSetAssistantBudgetError, AdminSetAssistantBudgetResponse, AdminUpdateFeedbackData, AdminUpdateFeedbackError, AdminUpdateFeedbackResponse, AdminUpdateSettingsData, AdminUpdateSettingsError, AdminUpdateSettingsResponse, AdminUpdateUserData, AdminUpdateUserError, AdminUpdateUserResponse, AssessmentsApproveAssessmentData, AssessmentsApproveAssessmentError, AssessmentsApproveAssessmentResponse, AssessmentsCreateAssessmentData, AssessmentsCreateAssessmentError, AssessmentsCreateAssessmentResponse, AssessmentsDeleteAssessmentData, AssessmentsDeleteAssessmentError, AssessmentsDeleteAssessmentResponse, AssessmentsEstimateAssessmentData, AssessmentsEstimateAssessmentError, AssessmentsEstimateAssessmentResponse, AssessmentsExportAssessmentXlsxData, AssessmentsExportAssessmentXlsxError, AssessmentsExportAssessmentXlsxResponse, AssessmentsGetAssessmentData, AssessmentsGetAssessmentError, AssessmentsGetAssessmentResponse, AssessmentsGetTopicResultData, AssessmentsGetTopicResultError, AssessmentsGetTopicResultResponse, AssessmentsGetVersionImpactData, AssessmentsGetVersionImpactError, AssessmentsGetVersionImpactResponse, AssessmentsListAssessmentsData, AssessmentsListAssessmentsError, AssessmentsListAssessmentsResponse, AssessmentsListTopicResultsData, AssessmentsListTopicResultsError, AssessmentsListTopicResultsResponse, AssessmentsReopenAssessmentData, AssessmentsReopenAssessmentError, AssessmentsReopenAssessmentResponse, AssessmentsRerunAssessmentData, AssessmentsRerunAssessmentError, AssessmentsRerunAssessmentResponse, AssessmentsReviewTopicResultData, AssessmentsReviewTopicResultError, AssessmentsReviewTopicResultResponse, AssistantDeleteThreadData, AssistantDeleteThreadError, AssistantDeleteThreadResponse, AssistantDeleteThreadsData, AssistantDeleteThreadsError, AssistantDeleteThreadsResponse, AssistantGetBudgetData, AssistantGetBudgetError, AssistantGetBudgetResponse, AssistantGetThreadData, AssistantGetThreadError, AssistantGetThreadResponse, AssistantListSuggestionsData, AssistantListSuggestionsError, AssistantListSuggestionsResponse, AssistantListThreadsData, AssistantListThreadsError, AssistantListThreadsResponse, AssistantRenameThreadData, AssistantRenameThreadError, AssistantRenameThreadResponse, AuthAcceptInvitationData, AuthAcceptInvitationError, AuthAcceptInvitationResponse, AuthChangePasswordData, AuthChangePasswordError, AuthChangePasswordResponse, AuthCompleteSignInData, AuthCompleteSignInError, AuthCompleteSignInResponse, AuthConfirmAuthenticatorReplacementData, AuthConfirmAuthenticatorReplacementError, AuthConfirmAuthenticatorReplacementResponse, AuthConfirmPasswordResetData, AuthConfirmPasswordResetError, AuthConfirmPasswordResetResponse, AuthConfirmSetupData, AuthConfirmSetupError, AuthConfirmSetupResponse, AuthGetAuthOptionsData, AuthGetAuthOptionsError, AuthGetAuthOptionsResponse, AuthGetPasswordPolicyData, AuthGetPasswordPolicyError, AuthGetPasswordPolicyResponse, AuthListSessionsData, AuthListSessionsError, AuthListSessionsResponse, AuthLookUpInvitationData, AuthLookUpInvitationError, AuthLookUpInvitationResponse, AuthLookUpPasswordResetData, AuthLookUpPasswordResetError, AuthLookUpPasswordResetResponse, AuthRequestPasswordResetData, AuthRequestPasswordResetError, AuthRevokeOtherSessionsData, AuthRevokeOtherSessionsError, AuthRevokeOtherSessionsResponse, AuthRevokeSessionData, AuthRevokeSessionError, AuthRevokeSessionResponse, AuthSignInData, AuthSignInError, AuthSignInResponse, AuthSignOutData, AuthSignOutError, AuthSignOutResponse, AuthStartAuthenticatorReplacementData, AuthStartAuthenticatorReplacementError, AuthStartAuthenticatorReplacementResponse, AuthStartSetupData, AuthStartSetupError, AuthStartSetupResponse, CapabilitiesCompleteCapabilityUploadData, CapabilitiesCompleteCapabilityUploadError, CapabilitiesCompleteCapabilityUploadResponse, CapabilitiesCreateCapabilityUploadData, CapabilitiesCreateCapabilityUploadError, CapabilitiesCreateCapabilityUploadResponse, CapabilitiesDeleteCapabilityDocumentData, CapabilitiesDeleteCapabilityDocumentError, CapabilitiesDeleteCapabilityDocumentResponse, CapabilitiesDeleteCapabilityUploadData, CapabilitiesDeleteCapabilityUploadError, CapabilitiesDeleteCapabilityUploadResponse, CapabilitiesExtractCapabilityDocumentData, CapabilitiesExtractCapabilityDocumentError, CapabilitiesExtractCapabilityDocumentResponse, CapabilitiesGetCapabilityDocumentData, CapabilitiesGetCapabilityDocumentError, CapabilitiesGetCapabilityDocumentPdfData, CapabilitiesGetCapabilityDocumentPdfError, CapabilitiesGetCapabilityDocumentPdfResponse, CapabilitiesGetCapabilityDocumentResponse, CapabilitiesGetCapabilityUploadData, CapabilitiesGetCapabilityUploadError, CapabilitiesGetCapabilityUploadResponse, CapabilitiesListCapabilitiesData, CapabilitiesListCapabilitiesError, CapabilitiesListCapabilitiesResponse, CapabilitiesListCapabilityDocumentsData, CapabilitiesListCapabilityDocumentsError, CapabilitiesListCapabilityDocumentsResponse, CapabilitiesPutCapabilityUploadPartData, CapabilitiesPutCapabilityUploadPartError, CapabilitiesPutCapabilityUploadPartResponse, CatalogGetCurrentDocumentData, CatalogGetCurrentDocumentError, CatalogGetCurrentDocumentResponse, CatalogGetDocumentData, CatalogGetDocumentError, CatalogGetDocumentResponse, CatalogGetDocumentStatsData, CatalogGetDocumentStatsError, CatalogGetDocumentStatsResponse, CatalogGetTableData, CatalogGetTableError, CatalogGetTableResponse, CatalogListAuthoritiesData, CatalogListAuthoritiesError, CatalogListAuthoritiesResponse, CatalogListDocumentsData, CatalogListDocumentsError, CatalogListDocumentsResponse, CatalogListFamiliesData, CatalogListFamiliesError, CatalogListFamiliesResponse, CatalogListFiguresData, CatalogListFiguresError, CatalogListFiguresResponse, CatalogListStandardsData, CatalogListStandardsError, CatalogListStandardsResponse, CatalogListTablesData, CatalogListTablesError, CatalogListTablesResponse, CatalogListThresholdsData, CatalogListThresholdsError, CatalogListThresholdsResponse, ClausesGetClauseData, ClausesGetClauseError, ClausesGetClauseResponse, ClausesGetTocData, ClausesGetTocError, ClausesGetTocResponse, ClausesListClausesData, ClausesListClausesError, ClausesListClausesResponse, ClausesListPageClausesData, ClausesListPageClausesError, ClausesListPageClausesResponse, CurvesGetChartData, CurvesGetChartError, CurvesGetChartResponse, CurvesGetCurveData, CurvesGetCurveError, CurvesGetCurveFacetsData, CurvesGetCurveFacetsError, CurvesGetCurveFacetsResponse, CurvesGetCurveResponse, CurvesListBandsData, CurvesListBandsError, CurvesListBandsResponse, CurvesListChartsData, CurvesListChartsError, CurvesListChartsResponse, CurvesListCurvesData, CurvesListCurvesError, CurvesListCurvesResponse, DatasetsGetDatasetPreviewData, DatasetsGetDatasetPreviewError, DatasetsGetDatasetPreviewResponse, DatasetsGetDatasetsOverviewData, DatasetsGetDatasetsOverviewError, DatasetsGetDatasetsOverviewResponse, DatasetsGetDocumentContentsData, DatasetsGetDocumentContentsError, DatasetsGetDocumentContentsResponse, DatasetsListDatasetsData, DatasetsListDatasetsError, DatasetsListDatasetsResponse, ExportsExportRequirementsCsvData, ExportsExportRequirementsCsvError, ExportsExportRequirementsCsvResponse, ExportsExportRequirementsXlsxData, ExportsExportRequirementsXlsxError, ExportsExportRequirementsXlsxResponse, FeedbackSendFeedbackData, FeedbackSendFeedbackError, FeedbackSendFeedbackResponse, JobsCancelJobData, JobsCancelJobError, JobsCancelJobResponse, JobsCreateJobData, JobsCreateJobError, JobsCreateJobResponse, JobsGetActiveJobCountData, JobsGetActiveJobCountError, JobsGetActiveJobCountResponse, JobsGetJobCapacityData, JobsGetJobCapacityError, JobsGetJobCapacityResponse, JobsGetJobData, JobsGetJobError, JobsGetJobEstimateData, JobsGetJobEstimateError, JobsGetJobEstimateResponse, JobsGetJobResponse, JobsGetRollbackImpactData, JobsGetRollbackImpactError, JobsGetRollbackImpactResponse, JobsListJobsData, JobsListJobsError, JobsListJobsResponse, LifecycleGetClauseContextDiffData, LifecycleGetClauseContextDiffError, LifecycleGetClauseContextDiffResponse, LifecycleGetVersionDiffData, LifecycleGetVersionDiffError, LifecycleGetVersionDiffResponse, LifecycleListFamilyVersionsData, LifecycleListFamilyVersionsError, LifecycleListFamilyVersionsResponse, LifecyclePromoteDocumentData, LifecyclePromoteDocumentError, LifecyclePromoteDocumentResponse, LifecycleSetDocumentStatusData, LifecycleSetDocumentStatusError, LifecycleSetDocumentStatusResponse, MetaGetHealthData, MetaGetHealthError, MetaGetHealthResponse, MetaGetMeData, MetaGetMeError, MetaGetMeResponse, MetaGetMetaData, MetaGetMetaError, MetaGetMetaResponse, MetaGetReadinessData, MetaGetReadinessError, MetaGetReadinessResponse, MetaListJurisdictionsData, MetaListJurisdictionsError, MetaListJurisdictionsResponse, OperationsGetConfidenceHistogramData, OperationsGetConfidenceHistogramError, OperationsGetConfidenceHistogramResponse, OperationsGetDocumentAuditData, OperationsGetDocumentAuditError, OperationsGetDocumentAuditResponse, OperationsGetDocumentIntegrityData, OperationsGetDocumentIntegrityError, OperationsGetDocumentIntegrityResponse, OperationsGetRunData, OperationsGetRunError, OperationsGetRunReportData, OperationsGetRunReportError, OperationsGetRunReportResponse, OperationsGetRunResponse, OperationsGetSourceWatchData, OperationsGetSourceWatchError, OperationsGetSourceWatchResponse, OperationsGetSystemStatusData, OperationsGetSystemStatusError, OperationsGetSystemStatusResponse, OperationsListActivityData, OperationsListActivityError, OperationsListActivityResponse, OperationsListCompletenessGapsData, OperationsListCompletenessGapsError, OperationsListCompletenessGapsResponse, OperationsListEvaluationsData, OperationsListEvaluationsError, OperationsListEvaluationsResponse, OperationsListRunsData, OperationsListRunsError, OperationsListRunsResponse, OperationsListSourcesData, OperationsListSourcesError, OperationsListSourcesResponse, RegistryCreateRegistryAuthorityData, RegistryCreateRegistryAuthorityError, RegistryCreateRegistryAuthorityResponse, RegistryCreateRegistryFamilyData, RegistryCreateRegistryFamilyError, RegistryCreateRegistryFamilyResponse, RegistryCreateRegistryJurisdictionData, RegistryCreateRegistryJurisdictionError, RegistryCreateRegistryJurisdictionResponse, RegistryCreateRegistryVersionData, RegistryCreateRegistryVersionError, RegistryCreateRegistryVersionResponse, RegistryExportSourceRegistryData, RegistryExportSourceRegistryError, RegistryExportSourceRegistryResponse, RegistryGetRegistryAuthorityData, RegistryGetRegistryAuthorityError, RegistryGetRegistryAuthorityResponse, RegistryGetRegistryFamilyData, RegistryGetRegistryFamilyError, RegistryGetRegistryFamilyResponse, RegistryGetRegistryJurisdictionData, RegistryGetRegistryJurisdictionError, RegistryGetRegistryJurisdictionResponse, RegistryGetRegistrySummaryData, RegistryGetRegistrySummaryError, RegistryGetRegistrySummaryResponse, RegistryGetRegistryVersionData, RegistryGetRegistryVersionError, RegistryGetRegistryVersionResponse, RegistryListDatasetEventsData, RegistryListDatasetEventsError, RegistryListDatasetEventsResponse, RegistryListRegistryAuthoritiesData, RegistryListRegistryAuthoritiesError, RegistryListRegistryAuthoritiesResponse, RegistryListRegistryFamiliesData, RegistryListRegistryFamiliesError, RegistryListRegistryFamiliesResponse, RegistryListRegistryJurisdictionsData, RegistryListRegistryJurisdictionsError, RegistryListRegistryJurisdictionsResponse, RegistryListRegistryRevisionsData, RegistryListRegistryRevisionsError, RegistryListRegistryRevisionsResponse, RegistryListSourceAdaptersData, RegistryListSourceAdaptersError, RegistryListSourceAdaptersResponse, RegistryListSupportedLanguagesData, RegistryListSupportedLanguagesError, RegistryListSupportedLanguagesResponse, RegistryReplaceFamilySectionsData, RegistryReplaceFamilySectionsError, RegistryReplaceFamilySectionsResponse, RegistryRetireRegistryAuthorityData, RegistryRetireRegistryAuthorityError, RegistryRetireRegistryAuthorityResponse, RegistryRetireRegistryFamilyData, RegistryRetireRegistryFamilyError, RegistryRetireRegistryFamilyResponse, RegistryRetireRegistryJurisdictionData, RegistryRetireRegistryJurisdictionError, RegistryRetireRegistryJurisdictionResponse, RegistryRetireRegistryVersionData, RegistryRetireRegistryVersionError, RegistryRetireRegistryVersionResponse, RegistryUpdateRegistryAuthorityData, RegistryUpdateRegistryAuthorityError, RegistryUpdateRegistryAuthorityResponse, RegistryUpdateRegistryFamilyData, RegistryUpdateRegistryFamilyError, RegistryUpdateRegistryFamilyResponse, RegistryUpdateRegistryJurisdictionData, RegistryUpdateRegistryJurisdictionError, RegistryUpdateRegistryJurisdictionResponse, RegistryUpdateRegistryVersionData, RegistryUpdateRegistryVersionError, RegistryUpdateRegistryVersionResponse, RegistryVerifyDatasetEventsData, RegistryVerifyDatasetEventsError, RegistryVerifyDatasetEventsResponse, RequirementsGetRequirementData, RequirementsGetRequirementError, RequirementsGetRequirementFacetsData, RequirementsGetRequirementFacetsError, RequirementsGetRequirementFacetsResponse, RequirementsGetRequirementResponse, RequirementsListRequirementsData, RequirementsListRequirementsError, RequirementsListRequirementsResponse, SearchGetOmniboxData, SearchGetOmniboxError, SearchGetOmniboxResponse, SearchSearchClausesData, SearchSearchClausesError, SearchSearchClausesResponse, SourcesGetDocumentPdfData, SourcesGetDocumentPdfError, SourcesGetDocumentPdfResponse, SourcesGetFigureImageData, SourcesGetFigureImageError, SourcesGetFigureImageResponse, SourcesGetPageHighlightsData, SourcesGetPageHighlightsError, SourcesGetPageHighlightsResponse, SourcesLocateTextsData, SourcesLocateTextsError, SourcesLocateTextsResponse, UploadsCompleteUploadData, UploadsCompleteUploadError, UploadsCompleteUploadResponse, UploadsCreateUploadData, UploadsCreateUploadError, UploadsCreateUploadResponse, UploadsDeleteUploadData, UploadsDeleteUploadError, UploadsDeleteUploadResponse, UploadsGetSourceFileData, UploadsGetSourceFileError, UploadsGetSourceFilePdfData, UploadsGetSourceFilePdfError, UploadsGetSourceFilePdfResponse, UploadsGetSourceFileResponse, UploadsGetSourceProfileData, UploadsGetSourceProfileError, UploadsGetSourceProfileResponse, UploadsGetUploadData, UploadsGetUploadError, UploadsGetUploadResponse, UploadsListSourceFilesData, UploadsListSourceFilesError, UploadsListSourceFilesResponse, UploadsPutUploadPartData, UploadsPutUploadPartError, UploadsPutUploadPartResponse, VocabularyGetDefinitionData, VocabularyGetDefinitionError, VocabularyGetDefinitionResponse, VocabularyGetParameterData, VocabularyGetParameterError, VocabularyGetParameterResponse, VocabularyListDefinitionsData, VocabularyListDefinitionsError, VocabularyListDefinitionsResponse, VocabularyListParameterGroupsData, VocabularyListParameterGroupsError, VocabularyListParameterGroupsResponse, VocabularyListParameterMarketsData, VocabularyListParameterMarketsError, VocabularyListParameterMarketsResponse, VocabularyListParametersData, VocabularyListParametersError, VocabularyListParametersResponse, VocabularyLookupDefinitionData, VocabularyLookupDefinitionError, VocabularyLookupDefinitionResponse, WhatsNewListEntriesData, WhatsNewListEntriesError, WhatsNewListEntriesResponse, WhatsNewMarkSeenData, WhatsNewMarkSeenError, WhatsNewMarkSeenResponse } from '../types.gen';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const operationsListActivityQueryKey = (options?: Options<OperationsListActivityData>) => createQueryKey('operationsListActivity', options);

/**
 * List Activity
 */
export const operationsListActivityOptions = (options?: Options<OperationsListActivityData>) => queryOptions<OperationsListActivityResponse, OperationsListActivityError, OperationsListActivityResponse, ReturnType<typeof operationsListActivityQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await operationsListActivity({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: operationsListActivityQueryKey(options)
});

export const adminListAuthEventsQueryKey = (options?: Options<AdminListAuthEventsData>) => createQueryKey('adminListAuthEvents', options);

/**
 * List Auth Events
 */
export const adminListAuthEventsOptions = (options?: Options<AdminListAuthEventsData>) => queryOptions<AdminListAuthEventsResponse, AdminListAuthEventsError, AdminListAuthEventsResponse, ReturnType<typeof adminListAuthEventsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminListAuthEvents({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminListAuthEventsQueryKey(options)
});

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(queryKey: QueryKey<Options>, page: K) => {
    const params = { ...queryKey[0] };
    if (page.body) {
        params.body = {
            ...queryKey[0].body as any,
            ...page.body as any
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path as any,
            ...page.path as any
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query as any,
            ...page.query as any
        };
    }
    return params as unknown as typeof page;
};

export const adminListAuthEventsInfiniteQueryKey = (options?: Options<AdminListAuthEventsData>): QueryKey<Options<AdminListAuthEventsData>> => createQueryKey('adminListAuthEvents', options, true);

/**
 * List Auth Events
 */
export const adminListAuthEventsInfiniteOptions = (options?: Options<AdminListAuthEventsData>) => {
    const opts = infiniteQueryOptions<AdminListAuthEventsResponse, AdminListAuthEventsError, InfiniteData<AdminListAuthEventsResponse>, QueryKey<Options<AdminListAuthEventsData>>, string | null | Pick<QueryKey<Options<AdminListAuthEventsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<AdminListAuthEventsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await adminListAuthEvents({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminListAuthEventsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const datasetsListDatasetsQueryKey = (options?: Options<DatasetsListDatasetsData>) => createQueryKey('datasetsListDatasets', options);

/**
 * List Datasets
 */
export const datasetsListDatasetsOptions = (options?: Options<DatasetsListDatasetsData>) => queryOptions<DatasetsListDatasetsResponse, DatasetsListDatasetsError, DatasetsListDatasetsResponse, ReturnType<typeof datasetsListDatasetsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await datasetsListDatasets({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: datasetsListDatasetsQueryKey(options)
});

export const datasetsListDatasetsInfiniteQueryKey = (options?: Options<DatasetsListDatasetsData>): QueryKey<Options<DatasetsListDatasetsData>> => createQueryKey('datasetsListDatasets', options, true);

/**
 * List Datasets
 */
export const datasetsListDatasetsInfiniteOptions = (options?: Options<DatasetsListDatasetsData>) => {
    const opts = infiniteQueryOptions<DatasetsListDatasetsResponse, DatasetsListDatasetsError, InfiniteData<DatasetsListDatasetsResponse>, QueryKey<Options<DatasetsListDatasetsData>>, string | null | Pick<QueryKey<Options<DatasetsListDatasetsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<DatasetsListDatasetsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await datasetsListDatasets({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: datasetsListDatasetsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const datasetsGetDatasetsOverviewQueryKey = (options?: Options<DatasetsGetDatasetsOverviewData>) => createQueryKey('datasetsGetDatasetsOverview', options);

/**
 * Get Datasets Overview
 */
export const datasetsGetDatasetsOverviewOptions = (options?: Options<DatasetsGetDatasetsOverviewData>) => queryOptions<DatasetsGetDatasetsOverviewResponse, DatasetsGetDatasetsOverviewError, DatasetsGetDatasetsOverviewResponse, ReturnType<typeof datasetsGetDatasetsOverviewQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await datasetsGetDatasetsOverview({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: datasetsGetDatasetsOverviewQueryKey(options)
});

export const datasetsGetDocumentContentsQueryKey = (options: Options<DatasetsGetDocumentContentsData>) => createQueryKey('datasetsGetDocumentContents', options);

/**
 * Get Document Contents
 */
export const datasetsGetDocumentContentsOptions = (options: Options<DatasetsGetDocumentContentsData>) => queryOptions<DatasetsGetDocumentContentsResponse, DatasetsGetDocumentContentsError, DatasetsGetDocumentContentsResponse, ReturnType<typeof datasetsGetDocumentContentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await datasetsGetDocumentContents({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: datasetsGetDocumentContentsQueryKey(options)
});

export const datasetsGetDatasetPreviewQueryKey = (options: Options<DatasetsGetDatasetPreviewData>) => createQueryKey('datasetsGetDatasetPreview', options);

/**
 * Get Dataset Preview
 */
export const datasetsGetDatasetPreviewOptions = (options: Options<DatasetsGetDatasetPreviewData>) => queryOptions<DatasetsGetDatasetPreviewResponse, DatasetsGetDatasetPreviewError, DatasetsGetDatasetPreviewResponse, ReturnType<typeof datasetsGetDatasetPreviewQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await datasetsGetDatasetPreview({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: datasetsGetDatasetPreviewQueryKey(options)
});

export const adminListFeedbackQueryKey = (options?: Options<AdminListFeedbackData>) => createQueryKey('adminListFeedback', options);

/**
 * List Feedback
 */
export const adminListFeedbackOptions = (options?: Options<AdminListFeedbackData>) => queryOptions<AdminListFeedbackResponse, AdminListFeedbackError, AdminListFeedbackResponse, ReturnType<typeof adminListFeedbackQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminListFeedback({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminListFeedbackQueryKey(options)
});

export const adminListFeedbackInfiniteQueryKey = (options?: Options<AdminListFeedbackData>): QueryKey<Options<AdminListFeedbackData>> => createQueryKey('adminListFeedback', options, true);

/**
 * List Feedback
 */
export const adminListFeedbackInfiniteOptions = (options?: Options<AdminListFeedbackData>) => {
    const opts = infiniteQueryOptions<AdminListFeedbackResponse, AdminListFeedbackError, InfiniteData<AdminListFeedbackResponse>, QueryKey<Options<AdminListFeedbackData>>, string | null | Pick<QueryKey<Options<AdminListFeedbackData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<AdminListFeedbackData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await adminListFeedback({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminListFeedbackInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const adminFeedbackSummaryQueryKey = (options?: Options<AdminFeedbackSummaryData>) => createQueryKey('adminFeedbackSummary', options);

/**
 * Feedback Summary
 */
export const adminFeedbackSummaryOptions = (options?: Options<AdminFeedbackSummaryData>) => queryOptions<AdminFeedbackSummaryResponse, AdminFeedbackSummaryError, AdminFeedbackSummaryResponse, ReturnType<typeof adminFeedbackSummaryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminFeedbackSummary({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminFeedbackSummaryQueryKey(options)
});

/**
 * Delete Feedback
 */
export const adminDeleteFeedbackMutation = (options?: Partial<Options<AdminDeleteFeedbackData>>): UseMutationOptions<AdminDeleteFeedbackResponse, AdminDeleteFeedbackError, Options<AdminDeleteFeedbackData>> => {
    const mutationOptions: UseMutationOptions<AdminDeleteFeedbackResponse, AdminDeleteFeedbackError, Options<AdminDeleteFeedbackData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminDeleteFeedback({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminGetFeedbackQueryKey = (options: Options<AdminGetFeedbackData>) => createQueryKey('adminGetFeedback', options);

/**
 * Get Feedback
 */
export const adminGetFeedbackOptions = (options: Options<AdminGetFeedbackData>) => queryOptions<AdminGetFeedbackResponse, AdminGetFeedbackError, AdminGetFeedbackResponse, ReturnType<typeof adminGetFeedbackQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminGetFeedback({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminGetFeedbackQueryKey(options)
});

/**
 * Update Feedback
 */
export const adminUpdateFeedbackMutation = (options?: Partial<Options<AdminUpdateFeedbackData>>): UseMutationOptions<AdminUpdateFeedbackResponse, AdminUpdateFeedbackError, Options<AdminUpdateFeedbackData>> => {
    const mutationOptions: UseMutationOptions<AdminUpdateFeedbackResponse, AdminUpdateFeedbackError, Options<AdminUpdateFeedbackData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUpdateFeedback({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminGetFeedbackScreenshotQueryKey = (options: Options<AdminGetFeedbackScreenshotData>) => createQueryKey('adminGetFeedbackScreenshot', options);

/**
 * Get Feedback Screenshot
 */
export const adminGetFeedbackScreenshotOptions = (options: Options<AdminGetFeedbackScreenshotData>) => queryOptions<AdminGetFeedbackScreenshotResponse, AdminGetFeedbackScreenshotError, AdminGetFeedbackScreenshotResponse, ReturnType<typeof adminGetFeedbackScreenshotQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminGetFeedbackScreenshot({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminGetFeedbackScreenshotQueryKey(options)
});

export const adminListInvitationsQueryKey = (options?: Options<AdminListInvitationsData>) => createQueryKey('adminListInvitations', options);

/**
 * List Invitations
 */
export const adminListInvitationsOptions = (options?: Options<AdminListInvitationsData>) => queryOptions<AdminListInvitationsResponse, AdminListInvitationsError, AdminListInvitationsResponse, ReturnType<typeof adminListInvitationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminListInvitations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminListInvitationsQueryKey(options)
});

export const adminListInvitationsInfiniteQueryKey = (options?: Options<AdminListInvitationsData>): QueryKey<Options<AdminListInvitationsData>> => createQueryKey('adminListInvitations', options, true);

/**
 * List Invitations
 */
export const adminListInvitationsInfiniteOptions = (options?: Options<AdminListInvitationsData>) => {
    const opts = infiniteQueryOptions<AdminListInvitationsResponse, AdminListInvitationsError, InfiniteData<AdminListInvitationsResponse>, QueryKey<Options<AdminListInvitationsData>>, string | null | Pick<QueryKey<Options<AdminListInvitationsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<AdminListInvitationsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await adminListInvitations({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminListInvitationsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Create Invitation
 */
export const adminCreateInvitationMutation = (options?: Partial<Options<AdminCreateInvitationData>>): UseMutationOptions<AdminCreateInvitationResponse, AdminCreateInvitationError, Options<AdminCreateInvitationData>> => {
    const mutationOptions: UseMutationOptions<AdminCreateInvitationResponse, AdminCreateInvitationError, Options<AdminCreateInvitationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminCreateInvitation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Revoke Invitation
 */
export const adminRevokeInvitationMutation = (options?: Partial<Options<AdminRevokeInvitationData>>): UseMutationOptions<AdminRevokeInvitationResponse, AdminRevokeInvitationError, Options<AdminRevokeInvitationData>> => {
    const mutationOptions: UseMutationOptions<AdminRevokeInvitationResponse, AdminRevokeInvitationError, Options<AdminRevokeInvitationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminRevokeInvitation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Resend Invitation
 */
export const adminResendInvitationMutation = (options?: Partial<Options<AdminResendInvitationData>>): UseMutationOptions<AdminResendInvitationResponse, AdminResendInvitationError, Options<AdminResendInvitationData>> => {
    const mutationOptions: UseMutationOptions<AdminResendInvitationResponse, AdminResendInvitationError, Options<AdminResendInvitationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminResendInvitation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const registryGetRegistrySummaryQueryKey = (options?: Options<RegistryGetRegistrySummaryData>) => createQueryKey('registryGetRegistrySummary', options);

/**
 * Get Registry Summary
 */
export const registryGetRegistrySummaryOptions = (options?: Options<RegistryGetRegistrySummaryData>) => queryOptions<RegistryGetRegistrySummaryResponse, RegistryGetRegistrySummaryError, RegistryGetRegistrySummaryResponse, ReturnType<typeof registryGetRegistrySummaryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await registryGetRegistrySummary({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: registryGetRegistrySummaryQueryKey(options)
});

export const registryListSourceAdaptersQueryKey = (options?: Options<RegistryListSourceAdaptersData>) => createQueryKey('registryListSourceAdapters', options);

/**
 * List Source Adapters
 */
export const registryListSourceAdaptersOptions = (options?: Options<RegistryListSourceAdaptersData>) => queryOptions<RegistryListSourceAdaptersResponse, RegistryListSourceAdaptersError, RegistryListSourceAdaptersResponse, ReturnType<typeof registryListSourceAdaptersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await registryListSourceAdapters({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: registryListSourceAdaptersQueryKey(options)
});

export const registryListRegistryAuthoritiesQueryKey = (options?: Options<RegistryListRegistryAuthoritiesData>) => createQueryKey('registryListRegistryAuthorities', options);

/**
 * List Registry Authorities
 */
export const registryListRegistryAuthoritiesOptions = (options?: Options<RegistryListRegistryAuthoritiesData>) => queryOptions<RegistryListRegistryAuthoritiesResponse, RegistryListRegistryAuthoritiesError, RegistryListRegistryAuthoritiesResponse, ReturnType<typeof registryListRegistryAuthoritiesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await registryListRegistryAuthorities({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: registryListRegistryAuthoritiesQueryKey(options)
});

export const registryListRegistryAuthoritiesInfiniteQueryKey = (options?: Options<RegistryListRegistryAuthoritiesData>): QueryKey<Options<RegistryListRegistryAuthoritiesData>> => createQueryKey('registryListRegistryAuthorities', options, true);

/**
 * List Registry Authorities
 */
export const registryListRegistryAuthoritiesInfiniteOptions = (options?: Options<RegistryListRegistryAuthoritiesData>) => {
    const opts = infiniteQueryOptions<RegistryListRegistryAuthoritiesResponse, RegistryListRegistryAuthoritiesError, InfiniteData<RegistryListRegistryAuthoritiesResponse>, QueryKey<Options<RegistryListRegistryAuthoritiesData>>, string | null | Pick<QueryKey<Options<RegistryListRegistryAuthoritiesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<RegistryListRegistryAuthoritiesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await registryListRegistryAuthorities({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: registryListRegistryAuthoritiesInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Create Registry Authority
 */
export const registryCreateRegistryAuthorityMutation = (options?: Partial<Options<RegistryCreateRegistryAuthorityData>>): UseMutationOptions<RegistryCreateRegistryAuthorityResponse, RegistryCreateRegistryAuthorityError, Options<RegistryCreateRegistryAuthorityData>> => {
    const mutationOptions: UseMutationOptions<RegistryCreateRegistryAuthorityResponse, RegistryCreateRegistryAuthorityError, Options<RegistryCreateRegistryAuthorityData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await registryCreateRegistryAuthority({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Retire Registry Authority
 */
export const registryRetireRegistryAuthorityMutation = (options?: Partial<Options<RegistryRetireRegistryAuthorityData>>): UseMutationOptions<RegistryRetireRegistryAuthorityResponse, RegistryRetireRegistryAuthorityError, Options<RegistryRetireRegistryAuthorityData>> => {
    const mutationOptions: UseMutationOptions<RegistryRetireRegistryAuthorityResponse, RegistryRetireRegistryAuthorityError, Options<RegistryRetireRegistryAuthorityData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await registryRetireRegistryAuthority({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const registryGetRegistryAuthorityQueryKey = (options: Options<RegistryGetRegistryAuthorityData>) => createQueryKey('registryGetRegistryAuthority', options);

/**
 * Get Registry Authority
 */
export const registryGetRegistryAuthorityOptions = (options: Options<RegistryGetRegistryAuthorityData>) => queryOptions<RegistryGetRegistryAuthorityResponse, RegistryGetRegistryAuthorityError, RegistryGetRegistryAuthorityResponse, ReturnType<typeof registryGetRegistryAuthorityQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await registryGetRegistryAuthority({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: registryGetRegistryAuthorityQueryKey(options)
});

/**
 * Update Registry Authority
 */
export const registryUpdateRegistryAuthorityMutation = (options?: Partial<Options<RegistryUpdateRegistryAuthorityData>>): UseMutationOptions<RegistryUpdateRegistryAuthorityResponse, RegistryUpdateRegistryAuthorityError, Options<RegistryUpdateRegistryAuthorityData>> => {
    const mutationOptions: UseMutationOptions<RegistryUpdateRegistryAuthorityResponse, RegistryUpdateRegistryAuthorityError, Options<RegistryUpdateRegistryAuthorityData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await registryUpdateRegistryAuthority({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const registryListRegistryRevisionsQueryKey = (options: Options<RegistryListRegistryRevisionsData>) => createQueryKey('registryListRegistryRevisions', options);

/**
 * List Registry Revisions
 */
export const registryListRegistryRevisionsOptions = (options: Options<RegistryListRegistryRevisionsData>) => queryOptions<RegistryListRegistryRevisionsResponse, RegistryListRegistryRevisionsError, RegistryListRegistryRevisionsResponse, ReturnType<typeof registryListRegistryRevisionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await registryListRegistryRevisions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: registryListRegistryRevisionsQueryKey(options)
});

export const registryListRegistryRevisionsInfiniteQueryKey = (options: Options<RegistryListRegistryRevisionsData>): QueryKey<Options<RegistryListRegistryRevisionsData>> => createQueryKey('registryListRegistryRevisions', options, true);

/**
 * List Registry Revisions
 */
export const registryListRegistryRevisionsInfiniteOptions = (options: Options<RegistryListRegistryRevisionsData>) => {
    const opts = infiniteQueryOptions<RegistryListRegistryRevisionsResponse, RegistryListRegistryRevisionsError, InfiniteData<RegistryListRegistryRevisionsResponse>, QueryKey<Options<RegistryListRegistryRevisionsData>>, string | null | Pick<QueryKey<Options<RegistryListRegistryRevisionsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<RegistryListRegistryRevisionsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await registryListRegistryRevisions({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: registryListRegistryRevisionsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const registryListDatasetEventsQueryKey = (options?: Options<RegistryListDatasetEventsData>) => createQueryKey('registryListDatasetEvents', options);

/**
 * List Dataset Events
 */
export const registryListDatasetEventsOptions = (options?: Options<RegistryListDatasetEventsData>) => queryOptions<RegistryListDatasetEventsResponse, RegistryListDatasetEventsError, RegistryListDatasetEventsResponse, ReturnType<typeof registryListDatasetEventsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await registryListDatasetEvents({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: registryListDatasetEventsQueryKey(options)
});

export const registryListDatasetEventsInfiniteQueryKey = (options?: Options<RegistryListDatasetEventsData>): QueryKey<Options<RegistryListDatasetEventsData>> => createQueryKey('registryListDatasetEvents', options, true);

/**
 * List Dataset Events
 */
export const registryListDatasetEventsInfiniteOptions = (options?: Options<RegistryListDatasetEventsData>) => {
    const opts = infiniteQueryOptions<RegistryListDatasetEventsResponse, RegistryListDatasetEventsError, InfiniteData<RegistryListDatasetEventsResponse>, QueryKey<Options<RegistryListDatasetEventsData>>, string | null | Pick<QueryKey<Options<RegistryListDatasetEventsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<RegistryListDatasetEventsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await registryListDatasetEvents({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: registryListDatasetEventsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const registryVerifyDatasetEventsQueryKey = (options?: Options<RegistryVerifyDatasetEventsData>) => createQueryKey('registryVerifyDatasetEvents', options);

/**
 * Verify Dataset Events
 */
export const registryVerifyDatasetEventsOptions = (options?: Options<RegistryVerifyDatasetEventsData>) => queryOptions<RegistryVerifyDatasetEventsResponse, RegistryVerifyDatasetEventsError, RegistryVerifyDatasetEventsResponse, ReturnType<typeof registryVerifyDatasetEventsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await registryVerifyDatasetEvents({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: registryVerifyDatasetEventsQueryKey(options)
});

export const registryExportSourceRegistryQueryKey = (options?: Options<RegistryExportSourceRegistryData>) => createQueryKey('registryExportSourceRegistry', options);

/**
 * Export Source Registry
 */
export const registryExportSourceRegistryOptions = (options?: Options<RegistryExportSourceRegistryData>) => queryOptions<RegistryExportSourceRegistryResponse, RegistryExportSourceRegistryError, RegistryExportSourceRegistryResponse, ReturnType<typeof registryExportSourceRegistryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await registryExportSourceRegistry({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: registryExportSourceRegistryQueryKey(options)
});

export const registryListRegistryFamiliesQueryKey = (options?: Options<RegistryListRegistryFamiliesData>) => createQueryKey('registryListRegistryFamilies', options);

/**
 * List Registry Families
 */
export const registryListRegistryFamiliesOptions = (options?: Options<RegistryListRegistryFamiliesData>) => queryOptions<RegistryListRegistryFamiliesResponse, RegistryListRegistryFamiliesError, RegistryListRegistryFamiliesResponse, ReturnType<typeof registryListRegistryFamiliesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await registryListRegistryFamilies({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: registryListRegistryFamiliesQueryKey(options)
});

export const registryListRegistryFamiliesInfiniteQueryKey = (options?: Options<RegistryListRegistryFamiliesData>): QueryKey<Options<RegistryListRegistryFamiliesData>> => createQueryKey('registryListRegistryFamilies', options, true);

/**
 * List Registry Families
 */
export const registryListRegistryFamiliesInfiniteOptions = (options?: Options<RegistryListRegistryFamiliesData>) => {
    const opts = infiniteQueryOptions<RegistryListRegistryFamiliesResponse, RegistryListRegistryFamiliesError, InfiniteData<RegistryListRegistryFamiliesResponse>, QueryKey<Options<RegistryListRegistryFamiliesData>>, string | null | Pick<QueryKey<Options<RegistryListRegistryFamiliesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<RegistryListRegistryFamiliesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await registryListRegistryFamilies({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: registryListRegistryFamiliesInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Create Registry Family
 */
export const registryCreateRegistryFamilyMutation = (options?: Partial<Options<RegistryCreateRegistryFamilyData>>): UseMutationOptions<RegistryCreateRegistryFamilyResponse, RegistryCreateRegistryFamilyError, Options<RegistryCreateRegistryFamilyData>> => {
    const mutationOptions: UseMutationOptions<RegistryCreateRegistryFamilyResponse, RegistryCreateRegistryFamilyError, Options<RegistryCreateRegistryFamilyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await registryCreateRegistryFamily({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Retire Registry Family
 */
export const registryRetireRegistryFamilyMutation = (options?: Partial<Options<RegistryRetireRegistryFamilyData>>): UseMutationOptions<RegistryRetireRegistryFamilyResponse, RegistryRetireRegistryFamilyError, Options<RegistryRetireRegistryFamilyData>> => {
    const mutationOptions: UseMutationOptions<RegistryRetireRegistryFamilyResponse, RegistryRetireRegistryFamilyError, Options<RegistryRetireRegistryFamilyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await registryRetireRegistryFamily({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const registryGetRegistryFamilyQueryKey = (options: Options<RegistryGetRegistryFamilyData>) => createQueryKey('registryGetRegistryFamily', options);

/**
 * Get Registry Family
 */
export const registryGetRegistryFamilyOptions = (options: Options<RegistryGetRegistryFamilyData>) => queryOptions<RegistryGetRegistryFamilyResponse, RegistryGetRegistryFamilyError, RegistryGetRegistryFamilyResponse, ReturnType<typeof registryGetRegistryFamilyQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await registryGetRegistryFamily({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: registryGetRegistryFamilyQueryKey(options)
});

/**
 * Update Registry Family
 */
export const registryUpdateRegistryFamilyMutation = (options?: Partial<Options<RegistryUpdateRegistryFamilyData>>): UseMutationOptions<RegistryUpdateRegistryFamilyResponse, RegistryUpdateRegistryFamilyError, Options<RegistryUpdateRegistryFamilyData>> => {
    const mutationOptions: UseMutationOptions<RegistryUpdateRegistryFamilyResponse, RegistryUpdateRegistryFamilyError, Options<RegistryUpdateRegistryFamilyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await registryUpdateRegistryFamily({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Replace Family Sections
 */
export const registryReplaceFamilySectionsMutation = (options?: Partial<Options<RegistryReplaceFamilySectionsData>>): UseMutationOptions<RegistryReplaceFamilySectionsResponse, RegistryReplaceFamilySectionsError, Options<RegistryReplaceFamilySectionsData>> => {
    const mutationOptions: UseMutationOptions<RegistryReplaceFamilySectionsResponse, RegistryReplaceFamilySectionsError, Options<RegistryReplaceFamilySectionsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await registryReplaceFamilySections({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Registry Version
 */
export const registryCreateRegistryVersionMutation = (options?: Partial<Options<RegistryCreateRegistryVersionData>>): UseMutationOptions<RegistryCreateRegistryVersionResponse, RegistryCreateRegistryVersionError, Options<RegistryCreateRegistryVersionData>> => {
    const mutationOptions: UseMutationOptions<RegistryCreateRegistryVersionResponse, RegistryCreateRegistryVersionError, Options<RegistryCreateRegistryVersionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await registryCreateRegistryVersion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Retire Registry Version
 */
export const registryRetireRegistryVersionMutation = (options?: Partial<Options<RegistryRetireRegistryVersionData>>): UseMutationOptions<RegistryRetireRegistryVersionResponse, RegistryRetireRegistryVersionError, Options<RegistryRetireRegistryVersionData>> => {
    const mutationOptions: UseMutationOptions<RegistryRetireRegistryVersionResponse, RegistryRetireRegistryVersionError, Options<RegistryRetireRegistryVersionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await registryRetireRegistryVersion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const registryGetRegistryVersionQueryKey = (options: Options<RegistryGetRegistryVersionData>) => createQueryKey('registryGetRegistryVersion', options);

/**
 * Get Registry Version
 */
export const registryGetRegistryVersionOptions = (options: Options<RegistryGetRegistryVersionData>) => queryOptions<RegistryGetRegistryVersionResponse, RegistryGetRegistryVersionError, RegistryGetRegistryVersionResponse, ReturnType<typeof registryGetRegistryVersionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await registryGetRegistryVersion({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: registryGetRegistryVersionQueryKey(options)
});

/**
 * Update Registry Version
 */
export const registryUpdateRegistryVersionMutation = (options?: Partial<Options<RegistryUpdateRegistryVersionData>>): UseMutationOptions<RegistryUpdateRegistryVersionResponse, RegistryUpdateRegistryVersionError, Options<RegistryUpdateRegistryVersionData>> => {
    const mutationOptions: UseMutationOptions<RegistryUpdateRegistryVersionResponse, RegistryUpdateRegistryVersionError, Options<RegistryUpdateRegistryVersionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await registryUpdateRegistryVersion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const registryListRegistryJurisdictionsQueryKey = (options?: Options<RegistryListRegistryJurisdictionsData>) => createQueryKey('registryListRegistryJurisdictions', options);

/**
 * List Registry Jurisdictions
 */
export const registryListRegistryJurisdictionsOptions = (options?: Options<RegistryListRegistryJurisdictionsData>) => queryOptions<RegistryListRegistryJurisdictionsResponse, RegistryListRegistryJurisdictionsError, RegistryListRegistryJurisdictionsResponse, ReturnType<typeof registryListRegistryJurisdictionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await registryListRegistryJurisdictions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: registryListRegistryJurisdictionsQueryKey(options)
});

export const registryListRegistryJurisdictionsInfiniteQueryKey = (options?: Options<RegistryListRegistryJurisdictionsData>): QueryKey<Options<RegistryListRegistryJurisdictionsData>> => createQueryKey('registryListRegistryJurisdictions', options, true);

/**
 * List Registry Jurisdictions
 */
export const registryListRegistryJurisdictionsInfiniteOptions = (options?: Options<RegistryListRegistryJurisdictionsData>) => {
    const opts = infiniteQueryOptions<RegistryListRegistryJurisdictionsResponse, RegistryListRegistryJurisdictionsError, InfiniteData<RegistryListRegistryJurisdictionsResponse>, QueryKey<Options<RegistryListRegistryJurisdictionsData>>, string | null | Pick<QueryKey<Options<RegistryListRegistryJurisdictionsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<RegistryListRegistryJurisdictionsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await registryListRegistryJurisdictions({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: registryListRegistryJurisdictionsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Create Registry Jurisdiction
 */
export const registryCreateRegistryJurisdictionMutation = (options?: Partial<Options<RegistryCreateRegistryJurisdictionData>>): UseMutationOptions<RegistryCreateRegistryJurisdictionResponse, RegistryCreateRegistryJurisdictionError, Options<RegistryCreateRegistryJurisdictionData>> => {
    const mutationOptions: UseMutationOptions<RegistryCreateRegistryJurisdictionResponse, RegistryCreateRegistryJurisdictionError, Options<RegistryCreateRegistryJurisdictionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await registryCreateRegistryJurisdiction({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Retire Registry Jurisdiction
 */
export const registryRetireRegistryJurisdictionMutation = (options?: Partial<Options<RegistryRetireRegistryJurisdictionData>>): UseMutationOptions<RegistryRetireRegistryJurisdictionResponse, RegistryRetireRegistryJurisdictionError, Options<RegistryRetireRegistryJurisdictionData>> => {
    const mutationOptions: UseMutationOptions<RegistryRetireRegistryJurisdictionResponse, RegistryRetireRegistryJurisdictionError, Options<RegistryRetireRegistryJurisdictionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await registryRetireRegistryJurisdiction({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const registryGetRegistryJurisdictionQueryKey = (options: Options<RegistryGetRegistryJurisdictionData>) => createQueryKey('registryGetRegistryJurisdiction', options);

/**
 * Get Registry Jurisdiction
 */
export const registryGetRegistryJurisdictionOptions = (options: Options<RegistryGetRegistryJurisdictionData>) => queryOptions<RegistryGetRegistryJurisdictionResponse, RegistryGetRegistryJurisdictionError, RegistryGetRegistryJurisdictionResponse, ReturnType<typeof registryGetRegistryJurisdictionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await registryGetRegistryJurisdiction({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: registryGetRegistryJurisdictionQueryKey(options)
});

/**
 * Update Registry Jurisdiction
 */
export const registryUpdateRegistryJurisdictionMutation = (options?: Partial<Options<RegistryUpdateRegistryJurisdictionData>>): UseMutationOptions<RegistryUpdateRegistryJurisdictionResponse, RegistryUpdateRegistryJurisdictionError, Options<RegistryUpdateRegistryJurisdictionData>> => {
    const mutationOptions: UseMutationOptions<RegistryUpdateRegistryJurisdictionResponse, RegistryUpdateRegistryJurisdictionError, Options<RegistryUpdateRegistryJurisdictionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await registryUpdateRegistryJurisdiction({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const registryListSupportedLanguagesQueryKey = (options?: Options<RegistryListSupportedLanguagesData>) => createQueryKey('registryListSupportedLanguages', options);

/**
 * List Supported Languages
 */
export const registryListSupportedLanguagesOptions = (options?: Options<RegistryListSupportedLanguagesData>) => queryOptions<RegistryListSupportedLanguagesResponse, RegistryListSupportedLanguagesError, RegistryListSupportedLanguagesResponse, ReturnType<typeof registryListSupportedLanguagesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await registryListSupportedLanguages({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: registryListSupportedLanguagesQueryKey(options)
});

export const adminGetSettingsQueryKey = (options?: Options<AdminGetSettingsData>) => createQueryKey('adminGetSettings', options);

/**
 * Get Settings
 */
export const adminGetSettingsOptions = (options?: Options<AdminGetSettingsData>) => queryOptions<AdminGetSettingsResponse, AdminGetSettingsError, AdminGetSettingsResponse, ReturnType<typeof adminGetSettingsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminGetSettings({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminGetSettingsQueryKey(options)
});

/**
 * Update Settings
 */
export const adminUpdateSettingsMutation = (options?: Partial<Options<AdminUpdateSettingsData>>): UseMutationOptions<AdminUpdateSettingsResponse, AdminUpdateSettingsError, Options<AdminUpdateSettingsData>> => {
    const mutationOptions: UseMutationOptions<AdminUpdateSettingsResponse, AdminUpdateSettingsError, Options<AdminUpdateSettingsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUpdateSettings({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminListSettingsHistoryQueryKey = (options?: Options<AdminListSettingsHistoryData>) => createQueryKey('adminListSettingsHistory', options);

/**
 * List Settings History
 */
export const adminListSettingsHistoryOptions = (options?: Options<AdminListSettingsHistoryData>) => queryOptions<AdminListSettingsHistoryResponse, AdminListSettingsHistoryError, AdminListSettingsHistoryResponse, ReturnType<typeof adminListSettingsHistoryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminListSettingsHistory({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminListSettingsHistoryQueryKey(options)
});

export const uploadsListSourceFilesQueryKey = (options?: Options<UploadsListSourceFilesData>) => createQueryKey('uploadsListSourceFiles', options);

/**
 * List Source Files
 */
export const uploadsListSourceFilesOptions = (options?: Options<UploadsListSourceFilesData>) => queryOptions<UploadsListSourceFilesResponse, UploadsListSourceFilesError, UploadsListSourceFilesResponse, ReturnType<typeof uploadsListSourceFilesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await uploadsListSourceFiles({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: uploadsListSourceFilesQueryKey(options)
});

export const uploadsListSourceFilesInfiniteQueryKey = (options?: Options<UploadsListSourceFilesData>): QueryKey<Options<UploadsListSourceFilesData>> => createQueryKey('uploadsListSourceFiles', options, true);

/**
 * List Source Files
 */
export const uploadsListSourceFilesInfiniteOptions = (options?: Options<UploadsListSourceFilesData>) => {
    const opts = infiniteQueryOptions<UploadsListSourceFilesResponse, UploadsListSourceFilesError, InfiniteData<UploadsListSourceFilesResponse>, QueryKey<Options<UploadsListSourceFilesData>>, string | null | Pick<QueryKey<Options<UploadsListSourceFilesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<UploadsListSourceFilesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await uploadsListSourceFiles({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: uploadsListSourceFilesInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const uploadsGetSourceFileQueryKey = (options: Options<UploadsGetSourceFileData>) => createQueryKey('uploadsGetSourceFile', options);

/**
 * Get Source File
 */
export const uploadsGetSourceFileOptions = (options: Options<UploadsGetSourceFileData>) => queryOptions<UploadsGetSourceFileResponse, UploadsGetSourceFileError, UploadsGetSourceFileResponse, ReturnType<typeof uploadsGetSourceFileQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await uploadsGetSourceFile({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: uploadsGetSourceFileQueryKey(options)
});

export const uploadsGetSourceFilePdfQueryKey = (options: Options<UploadsGetSourceFilePdfData>) => createQueryKey('uploadsGetSourceFilePdf', options);

/**
 * Get Source File Pdf
 */
export const uploadsGetSourceFilePdfOptions = (options: Options<UploadsGetSourceFilePdfData>) => queryOptions<UploadsGetSourceFilePdfResponse, UploadsGetSourceFilePdfError, UploadsGetSourceFilePdfResponse, ReturnType<typeof uploadsGetSourceFilePdfQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await uploadsGetSourceFilePdf({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: uploadsGetSourceFilePdfQueryKey(options)
});

export const uploadsGetSourceProfileQueryKey = (options: Options<UploadsGetSourceProfileData>) => createQueryKey('uploadsGetSourceProfile', options);

/**
 * Get Source Profile
 */
export const uploadsGetSourceProfileOptions = (options: Options<UploadsGetSourceProfileData>) => queryOptions<UploadsGetSourceProfileResponse, UploadsGetSourceProfileError, UploadsGetSourceProfileResponse, ReturnType<typeof uploadsGetSourceProfileQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await uploadsGetSourceProfile({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: uploadsGetSourceProfileQueryKey(options)
});

/**
 * Create Upload
 */
export const uploadsCreateUploadMutation = (options?: Partial<Options<UploadsCreateUploadData>>): UseMutationOptions<UploadsCreateUploadResponse, UploadsCreateUploadError, Options<UploadsCreateUploadData>> => {
    const mutationOptions: UseMutationOptions<UploadsCreateUploadResponse, UploadsCreateUploadError, Options<UploadsCreateUploadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await uploadsCreateUpload({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Upload
 */
export const uploadsDeleteUploadMutation = (options?: Partial<Options<UploadsDeleteUploadData>>): UseMutationOptions<UploadsDeleteUploadResponse, UploadsDeleteUploadError, Options<UploadsDeleteUploadData>> => {
    const mutationOptions: UseMutationOptions<UploadsDeleteUploadResponse, UploadsDeleteUploadError, Options<UploadsDeleteUploadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await uploadsDeleteUpload({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const uploadsGetUploadQueryKey = (options: Options<UploadsGetUploadData>) => createQueryKey('uploadsGetUpload', options);

/**
 * Get Upload
 */
export const uploadsGetUploadOptions = (options: Options<UploadsGetUploadData>) => queryOptions<UploadsGetUploadResponse, UploadsGetUploadError, UploadsGetUploadResponse, ReturnType<typeof uploadsGetUploadQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await uploadsGetUpload({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: uploadsGetUploadQueryKey(options)
});

/**
 * Complete Upload
 */
export const uploadsCompleteUploadMutation = (options?: Partial<Options<UploadsCompleteUploadData>>): UseMutationOptions<UploadsCompleteUploadResponse, UploadsCompleteUploadError, Options<UploadsCompleteUploadData>> => {
    const mutationOptions: UseMutationOptions<UploadsCompleteUploadResponse, UploadsCompleteUploadError, Options<UploadsCompleteUploadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await uploadsCompleteUpload({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Put Upload Part
 */
export const uploadsPutUploadPartMutation = (options?: Partial<Options<UploadsPutUploadPartData>>): UseMutationOptions<UploadsPutUploadPartResponse, UploadsPutUploadPartError, Options<UploadsPutUploadPartData>> => {
    const mutationOptions: UseMutationOptions<UploadsPutUploadPartResponse, UploadsPutUploadPartError, Options<UploadsPutUploadPartData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await uploadsPutUploadPart({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminListUsersQueryKey = (options?: Options<AdminListUsersData>) => createQueryKey('adminListUsers', options);

/**
 * List Users
 */
export const adminListUsersOptions = (options?: Options<AdminListUsersData>) => queryOptions<AdminListUsersResponse, AdminListUsersError, AdminListUsersResponse, ReturnType<typeof adminListUsersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminListUsers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminListUsersQueryKey(options)
});

export const adminListUsersInfiniteQueryKey = (options?: Options<AdminListUsersData>): QueryKey<Options<AdminListUsersData>> => createQueryKey('adminListUsers', options, true);

/**
 * List Users
 */
export const adminListUsersInfiniteOptions = (options?: Options<AdminListUsersData>) => {
    const opts = infiniteQueryOptions<AdminListUsersResponse, AdminListUsersError, InfiniteData<AdminListUsersResponse>, QueryKey<Options<AdminListUsersData>>, string | null | Pick<QueryKey<Options<AdminListUsersData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<AdminListUsersData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await adminListUsers({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminListUsersInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const adminGetUserQueryKey = (options: Options<AdminGetUserData>) => createQueryKey('adminGetUser', options);

/**
 * Get User
 */
export const adminGetUserOptions = (options: Options<AdminGetUserData>) => queryOptions<AdminGetUserResponse, AdminGetUserError, AdminGetUserResponse, ReturnType<typeof adminGetUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminGetUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminGetUserQueryKey(options)
});

/**
 * Update User
 */
export const adminUpdateUserMutation = (options?: Partial<Options<AdminUpdateUserData>>): UseMutationOptions<AdminUpdateUserResponse, AdminUpdateUserError, Options<AdminUpdateUserData>> => {
    const mutationOptions: UseMutationOptions<AdminUpdateUserResponse, AdminUpdateUserError, Options<AdminUpdateUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUpdateUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Set Assistant Budget
 */
export const adminSetAssistantBudgetMutation = (options?: Partial<Options<AdminSetAssistantBudgetData>>): UseMutationOptions<AdminSetAssistantBudgetResponse, AdminSetAssistantBudgetError, Options<AdminSetAssistantBudgetData>> => {
    const mutationOptions: UseMutationOptions<AdminSetAssistantBudgetResponse, AdminSetAssistantBudgetError, Options<AdminSetAssistantBudgetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminSetAssistantBudget({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reset User Mfa
 */
export const adminResetUserMfaMutation = (options?: Partial<Options<AdminResetUserMfaData>>): UseMutationOptions<AdminResetUserMfaResponse, AdminResetUserMfaError, Options<AdminResetUserMfaData>> => {
    const mutationOptions: UseMutationOptions<AdminResetUserMfaResponse, AdminResetUserMfaError, Options<AdminResetUserMfaData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminResetUserMfa({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Send Password Reset
 */
export const adminSendPasswordResetMutation = (options?: Partial<Options<AdminSendPasswordResetData>>): UseMutationOptions<AdminSendPasswordResetResponse, AdminSendPasswordResetError, Options<AdminSendPasswordResetData>> => {
    const mutationOptions: UseMutationOptions<AdminSendPasswordResetResponse, AdminSendPasswordResetError, Options<AdminSendPasswordResetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminSendPasswordReset({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Revoke User Sessions
 */
export const adminRevokeUserSessionsMutation = (options?: Partial<Options<AdminRevokeUserSessionsData>>): UseMutationOptions<AdminRevokeUserSessionsResponse, AdminRevokeUserSessionsError, Options<AdminRevokeUserSessionsData>> => {
    const mutationOptions: UseMutationOptions<AdminRevokeUserSessionsResponse, AdminRevokeUserSessionsError, Options<AdminRevokeUserSessionsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminRevokeUserSessions({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const assessmentsListAssessmentsQueryKey = (options?: Options<AssessmentsListAssessmentsData>) => createQueryKey('assessmentsListAssessments', options);

/**
 * List Assessments
 */
export const assessmentsListAssessmentsOptions = (options?: Options<AssessmentsListAssessmentsData>) => queryOptions<AssessmentsListAssessmentsResponse, AssessmentsListAssessmentsError, AssessmentsListAssessmentsResponse, ReturnType<typeof assessmentsListAssessmentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await assessmentsListAssessments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: assessmentsListAssessmentsQueryKey(options)
});

/**
 * Create Assessment
 */
export const assessmentsCreateAssessmentMutation = (options?: Partial<Options<AssessmentsCreateAssessmentData>>): UseMutationOptions<AssessmentsCreateAssessmentResponse, AssessmentsCreateAssessmentError, Options<AssessmentsCreateAssessmentData>> => {
    const mutationOptions: UseMutationOptions<AssessmentsCreateAssessmentResponse, AssessmentsCreateAssessmentError, Options<AssessmentsCreateAssessmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await assessmentsCreateAssessment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const assessmentsEstimateAssessmentQueryKey = (options: Options<AssessmentsEstimateAssessmentData>) => createQueryKey('assessmentsEstimateAssessment', options);

/**
 * Estimate Assessment
 */
export const assessmentsEstimateAssessmentOptions = (options: Options<AssessmentsEstimateAssessmentData>) => queryOptions<AssessmentsEstimateAssessmentResponse, AssessmentsEstimateAssessmentError, AssessmentsEstimateAssessmentResponse, ReturnType<typeof assessmentsEstimateAssessmentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await assessmentsEstimateAssessment({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: assessmentsEstimateAssessmentQueryKey(options)
});

/**
 * Delete Assessment
 */
export const assessmentsDeleteAssessmentMutation = (options?: Partial<Options<AssessmentsDeleteAssessmentData>>): UseMutationOptions<AssessmentsDeleteAssessmentResponse, AssessmentsDeleteAssessmentError, Options<AssessmentsDeleteAssessmentData>> => {
    const mutationOptions: UseMutationOptions<AssessmentsDeleteAssessmentResponse, AssessmentsDeleteAssessmentError, Options<AssessmentsDeleteAssessmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await assessmentsDeleteAssessment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const assessmentsGetAssessmentQueryKey = (options: Options<AssessmentsGetAssessmentData>) => createQueryKey('assessmentsGetAssessment', options);

/**
 * Get Assessment
 */
export const assessmentsGetAssessmentOptions = (options: Options<AssessmentsGetAssessmentData>) => queryOptions<AssessmentsGetAssessmentResponse, AssessmentsGetAssessmentError, AssessmentsGetAssessmentResponse, ReturnType<typeof assessmentsGetAssessmentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await assessmentsGetAssessment({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: assessmentsGetAssessmentQueryKey(options)
});

/**
 * Approve Assessment
 */
export const assessmentsApproveAssessmentMutation = (options?: Partial<Options<AssessmentsApproveAssessmentData>>): UseMutationOptions<AssessmentsApproveAssessmentResponse, AssessmentsApproveAssessmentError, Options<AssessmentsApproveAssessmentData>> => {
    const mutationOptions: UseMutationOptions<AssessmentsApproveAssessmentResponse, AssessmentsApproveAssessmentError, Options<AssessmentsApproveAssessmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await assessmentsApproveAssessment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const assessmentsExportAssessmentXlsxQueryKey = (options: Options<AssessmentsExportAssessmentXlsxData>) => createQueryKey('assessmentsExportAssessmentXlsx', options);

/**
 * Export Assessment Xlsx
 */
export const assessmentsExportAssessmentXlsxOptions = (options: Options<AssessmentsExportAssessmentXlsxData>) => queryOptions<AssessmentsExportAssessmentXlsxResponse, AssessmentsExportAssessmentXlsxError, AssessmentsExportAssessmentXlsxResponse, ReturnType<typeof assessmentsExportAssessmentXlsxQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await assessmentsExportAssessmentXlsx({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: assessmentsExportAssessmentXlsxQueryKey(options)
});

/**
 * Reopen Assessment
 */
export const assessmentsReopenAssessmentMutation = (options?: Partial<Options<AssessmentsReopenAssessmentData>>): UseMutationOptions<AssessmentsReopenAssessmentResponse, AssessmentsReopenAssessmentError, Options<AssessmentsReopenAssessmentData>> => {
    const mutationOptions: UseMutationOptions<AssessmentsReopenAssessmentResponse, AssessmentsReopenAssessmentError, Options<AssessmentsReopenAssessmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await assessmentsReopenAssessment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Rerun Assessment
 */
export const assessmentsRerunAssessmentMutation = (options?: Partial<Options<AssessmentsRerunAssessmentData>>): UseMutationOptions<AssessmentsRerunAssessmentResponse, AssessmentsRerunAssessmentError, Options<AssessmentsRerunAssessmentData>> => {
    const mutationOptions: UseMutationOptions<AssessmentsRerunAssessmentResponse, AssessmentsRerunAssessmentError, Options<AssessmentsRerunAssessmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await assessmentsRerunAssessment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const assessmentsListTopicResultsQueryKey = (options: Options<AssessmentsListTopicResultsData>) => createQueryKey('assessmentsListTopicResults', options);

/**
 * List Topic Results
 */
export const assessmentsListTopicResultsOptions = (options: Options<AssessmentsListTopicResultsData>) => queryOptions<AssessmentsListTopicResultsResponse, AssessmentsListTopicResultsError, AssessmentsListTopicResultsResponse, ReturnType<typeof assessmentsListTopicResultsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await assessmentsListTopicResults({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: assessmentsListTopicResultsQueryKey(options)
});

export const assessmentsGetTopicResultQueryKey = (options: Options<AssessmentsGetTopicResultData>) => createQueryKey('assessmentsGetTopicResult', options);

/**
 * Get Topic Result
 */
export const assessmentsGetTopicResultOptions = (options: Options<AssessmentsGetTopicResultData>) => queryOptions<AssessmentsGetTopicResultResponse, AssessmentsGetTopicResultError, AssessmentsGetTopicResultResponse, ReturnType<typeof assessmentsGetTopicResultQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await assessmentsGetTopicResult({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: assessmentsGetTopicResultQueryKey(options)
});

/**
 * Review Topic Result
 */
export const assessmentsReviewTopicResultMutation = (options?: Partial<Options<AssessmentsReviewTopicResultData>>): UseMutationOptions<AssessmentsReviewTopicResultResponse, AssessmentsReviewTopicResultError, Options<AssessmentsReviewTopicResultData>> => {
    const mutationOptions: UseMutationOptions<AssessmentsReviewTopicResultResponse, AssessmentsReviewTopicResultError, Options<AssessmentsReviewTopicResultData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await assessmentsReviewTopicResult({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const assessmentsGetVersionImpactQueryKey = (options: Options<AssessmentsGetVersionImpactData>) => createQueryKey('assessmentsGetVersionImpact', options);

/**
 * Get Version Impact
 */
export const assessmentsGetVersionImpactOptions = (options: Options<AssessmentsGetVersionImpactData>) => queryOptions<AssessmentsGetVersionImpactResponse, AssessmentsGetVersionImpactError, AssessmentsGetVersionImpactResponse, ReturnType<typeof assessmentsGetVersionImpactQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await assessmentsGetVersionImpact({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: assessmentsGetVersionImpactQueryKey(options)
});

export const assistantGetBudgetQueryKey = (options?: Options<AssistantGetBudgetData>) => createQueryKey('assistantGetBudget', options);

/**
 * Get Budget
 */
export const assistantGetBudgetOptions = (options?: Options<AssistantGetBudgetData>) => queryOptions<AssistantGetBudgetResponse, AssistantGetBudgetError, AssistantGetBudgetResponse, ReturnType<typeof assistantGetBudgetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await assistantGetBudget({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: assistantGetBudgetQueryKey(options)
});

export const assistantListSuggestionsQueryKey = (options?: Options<AssistantListSuggestionsData>) => createQueryKey('assistantListSuggestions', options);

/**
 * List Suggestions
 */
export const assistantListSuggestionsOptions = (options?: Options<AssistantListSuggestionsData>) => queryOptions<AssistantListSuggestionsResponse, AssistantListSuggestionsError, AssistantListSuggestionsResponse, ReturnType<typeof assistantListSuggestionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await assistantListSuggestions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: assistantListSuggestionsQueryKey(options)
});

/**
 * Delete Threads
 */
export const assistantDeleteThreadsMutation = (options?: Partial<Options<AssistantDeleteThreadsData>>): UseMutationOptions<AssistantDeleteThreadsResponse, AssistantDeleteThreadsError, Options<AssistantDeleteThreadsData>> => {
    const mutationOptions: UseMutationOptions<AssistantDeleteThreadsResponse, AssistantDeleteThreadsError, Options<AssistantDeleteThreadsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await assistantDeleteThreads({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const assistantListThreadsQueryKey = (options?: Options<AssistantListThreadsData>) => createQueryKey('assistantListThreads', options);

/**
 * List Threads
 */
export const assistantListThreadsOptions = (options?: Options<AssistantListThreadsData>) => queryOptions<AssistantListThreadsResponse, AssistantListThreadsError, AssistantListThreadsResponse, ReturnType<typeof assistantListThreadsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await assistantListThreads({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: assistantListThreadsQueryKey(options)
});

export const assistantListThreadsInfiniteQueryKey = (options?: Options<AssistantListThreadsData>): QueryKey<Options<AssistantListThreadsData>> => createQueryKey('assistantListThreads', options, true);

/**
 * List Threads
 */
export const assistantListThreadsInfiniteOptions = (options?: Options<AssistantListThreadsData>) => {
    const opts = infiniteQueryOptions<AssistantListThreadsResponse, AssistantListThreadsError, InfiniteData<AssistantListThreadsResponse>, QueryKey<Options<AssistantListThreadsData>>, string | null | Pick<QueryKey<Options<AssistantListThreadsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<AssistantListThreadsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await assistantListThreads({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: assistantListThreadsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Delete Thread
 */
export const assistantDeleteThreadMutation = (options?: Partial<Options<AssistantDeleteThreadData>>): UseMutationOptions<AssistantDeleteThreadResponse, AssistantDeleteThreadError, Options<AssistantDeleteThreadData>> => {
    const mutationOptions: UseMutationOptions<AssistantDeleteThreadResponse, AssistantDeleteThreadError, Options<AssistantDeleteThreadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await assistantDeleteThread({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const assistantGetThreadQueryKey = (options: Options<AssistantGetThreadData>) => createQueryKey('assistantGetThread', options);

/**
 * Get Thread
 */
export const assistantGetThreadOptions = (options: Options<AssistantGetThreadData>) => queryOptions<AssistantGetThreadResponse, AssistantGetThreadError, AssistantGetThreadResponse, ReturnType<typeof assistantGetThreadQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await assistantGetThread({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: assistantGetThreadQueryKey(options)
});

/**
 * Rename Thread
 */
export const assistantRenameThreadMutation = (options?: Partial<Options<AssistantRenameThreadData>>): UseMutationOptions<AssistantRenameThreadResponse, AssistantRenameThreadError, Options<AssistantRenameThreadData>> => {
    const mutationOptions: UseMutationOptions<AssistantRenameThreadResponse, AssistantRenameThreadError, Options<AssistantRenameThreadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await assistantRenameThread({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Accept Invitation
 */
export const authAcceptInvitationMutation = (options?: Partial<Options<AuthAcceptInvitationData>>): UseMutationOptions<AuthAcceptInvitationResponse, AuthAcceptInvitationError, Options<AuthAcceptInvitationData>> => {
    const mutationOptions: UseMutationOptions<AuthAcceptInvitationResponse, AuthAcceptInvitationError, Options<AuthAcceptInvitationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await authAcceptInvitation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Look Up Invitation
 */
export const authLookUpInvitationMutation = (options?: Partial<Options<AuthLookUpInvitationData>>): UseMutationOptions<AuthLookUpInvitationResponse, AuthLookUpInvitationError, Options<AuthLookUpInvitationData>> => {
    const mutationOptions: UseMutationOptions<AuthLookUpInvitationResponse, AuthLookUpInvitationError, Options<AuthLookUpInvitationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await authLookUpInvitation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Start Authenticator Replacement
 */
export const authStartAuthenticatorReplacementMutation = (options?: Partial<Options<AuthStartAuthenticatorReplacementData>>): UseMutationOptions<AuthStartAuthenticatorReplacementResponse, AuthStartAuthenticatorReplacementError, Options<AuthStartAuthenticatorReplacementData>> => {
    const mutationOptions: UseMutationOptions<AuthStartAuthenticatorReplacementResponse, AuthStartAuthenticatorReplacementError, Options<AuthStartAuthenticatorReplacementData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await authStartAuthenticatorReplacement({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Confirm Authenticator Replacement
 */
export const authConfirmAuthenticatorReplacementMutation = (options?: Partial<Options<AuthConfirmAuthenticatorReplacementData>>): UseMutationOptions<AuthConfirmAuthenticatorReplacementResponse, AuthConfirmAuthenticatorReplacementError, Options<AuthConfirmAuthenticatorReplacementData>> => {
    const mutationOptions: UseMutationOptions<AuthConfirmAuthenticatorReplacementResponse, AuthConfirmAuthenticatorReplacementError, Options<AuthConfirmAuthenticatorReplacementData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await authConfirmAuthenticatorReplacement({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const authGetAuthOptionsQueryKey = (options?: Options<AuthGetAuthOptionsData>) => createQueryKey('authGetAuthOptions', options);

/**
 * Get Auth Options
 */
export const authGetAuthOptionsOptions = (options?: Options<AuthGetAuthOptionsData>) => queryOptions<AuthGetAuthOptionsResponse, AuthGetAuthOptionsError, AuthGetAuthOptionsResponse, ReturnType<typeof authGetAuthOptionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await authGetAuthOptions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: authGetAuthOptionsQueryKey(options)
});

/**
 * Change Password
 */
export const authChangePasswordMutation = (options?: Partial<Options<AuthChangePasswordData>>): UseMutationOptions<AuthChangePasswordResponse, AuthChangePasswordError, Options<AuthChangePasswordData>> => {
    const mutationOptions: UseMutationOptions<AuthChangePasswordResponse, AuthChangePasswordError, Options<AuthChangePasswordData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await authChangePassword({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const authGetPasswordPolicyQueryKey = (options?: Options<AuthGetPasswordPolicyData>) => createQueryKey('authGetPasswordPolicy', options);

/**
 * Get Password Policy
 */
export const authGetPasswordPolicyOptions = (options?: Options<AuthGetPasswordPolicyData>) => queryOptions<AuthGetPasswordPolicyResponse, AuthGetPasswordPolicyError, AuthGetPasswordPolicyResponse, ReturnType<typeof authGetPasswordPolicyQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await authGetPasswordPolicy({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: authGetPasswordPolicyQueryKey(options)
});

/**
 * Request Password Reset
 */
export const authRequestPasswordResetMutation = (options?: Partial<Options<AuthRequestPasswordResetData>>): UseMutationOptions<unknown, AuthRequestPasswordResetError, Options<AuthRequestPasswordResetData>> => {
    const mutationOptions: UseMutationOptions<unknown, AuthRequestPasswordResetError, Options<AuthRequestPasswordResetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await authRequestPasswordReset({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Confirm Password Reset
 */
export const authConfirmPasswordResetMutation = (options?: Partial<Options<AuthConfirmPasswordResetData>>): UseMutationOptions<AuthConfirmPasswordResetResponse, AuthConfirmPasswordResetError, Options<AuthConfirmPasswordResetData>> => {
    const mutationOptions: UseMutationOptions<AuthConfirmPasswordResetResponse, AuthConfirmPasswordResetError, Options<AuthConfirmPasswordResetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await authConfirmPasswordReset({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Look Up Password Reset
 */
export const authLookUpPasswordResetMutation = (options?: Partial<Options<AuthLookUpPasswordResetData>>): UseMutationOptions<AuthLookUpPasswordResetResponse, AuthLookUpPasswordResetError, Options<AuthLookUpPasswordResetData>> => {
    const mutationOptions: UseMutationOptions<AuthLookUpPasswordResetResponse, AuthLookUpPasswordResetError, Options<AuthLookUpPasswordResetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await authLookUpPasswordReset({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Revoke Other Sessions
 */
export const authRevokeOtherSessionsMutation = (options?: Partial<Options<AuthRevokeOtherSessionsData>>): UseMutationOptions<AuthRevokeOtherSessionsResponse, AuthRevokeOtherSessionsError, Options<AuthRevokeOtherSessionsData>> => {
    const mutationOptions: UseMutationOptions<AuthRevokeOtherSessionsResponse, AuthRevokeOtherSessionsError, Options<AuthRevokeOtherSessionsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await authRevokeOtherSessions({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const authListSessionsQueryKey = (options?: Options<AuthListSessionsData>) => createQueryKey('authListSessions', options);

/**
 * List Sessions
 */
export const authListSessionsOptions = (options?: Options<AuthListSessionsData>) => queryOptions<AuthListSessionsResponse, AuthListSessionsError, AuthListSessionsResponse, ReturnType<typeof authListSessionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await authListSessions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: authListSessionsQueryKey(options)
});

/**
 * Revoke Session
 */
export const authRevokeSessionMutation = (options?: Partial<Options<AuthRevokeSessionData>>): UseMutationOptions<AuthRevokeSessionResponse, AuthRevokeSessionError, Options<AuthRevokeSessionData>> => {
    const mutationOptions: UseMutationOptions<AuthRevokeSessionResponse, AuthRevokeSessionError, Options<AuthRevokeSessionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await authRevokeSession({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Sign In
 */
export const authSignInMutation = (options?: Partial<Options<AuthSignInData>>): UseMutationOptions<AuthSignInResponse, AuthSignInError, Options<AuthSignInData>> => {
    const mutationOptions: UseMutationOptions<AuthSignInResponse, AuthSignInError, Options<AuthSignInData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await authSignIn({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Complete Sign In
 */
export const authCompleteSignInMutation = (options?: Partial<Options<AuthCompleteSignInData>>): UseMutationOptions<AuthCompleteSignInResponse, AuthCompleteSignInError, Options<AuthCompleteSignInData>> => {
    const mutationOptions: UseMutationOptions<AuthCompleteSignInResponse, AuthCompleteSignInError, Options<AuthCompleteSignInData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await authCompleteSignIn({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Start Setup
 */
export const authStartSetupMutation = (options?: Partial<Options<AuthStartSetupData>>): UseMutationOptions<AuthStartSetupResponse, AuthStartSetupError, Options<AuthStartSetupData>> => {
    const mutationOptions: UseMutationOptions<AuthStartSetupResponse, AuthStartSetupError, Options<AuthStartSetupData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await authStartSetup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Confirm Setup
 */
export const authConfirmSetupMutation = (options?: Partial<Options<AuthConfirmSetupData>>): UseMutationOptions<AuthConfirmSetupResponse, AuthConfirmSetupError, Options<AuthConfirmSetupData>> => {
    const mutationOptions: UseMutationOptions<AuthConfirmSetupResponse, AuthConfirmSetupError, Options<AuthConfirmSetupData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await authConfirmSetup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Sign Out
 */
export const authSignOutMutation = (options?: Partial<Options<AuthSignOutData>>): UseMutationOptions<AuthSignOutResponse, AuthSignOutError, Options<AuthSignOutData>> => {
    const mutationOptions: UseMutationOptions<AuthSignOutResponse, AuthSignOutError, Options<AuthSignOutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await authSignOut({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const catalogListAuthoritiesQueryKey = (options?: Options<CatalogListAuthoritiesData>) => createQueryKey('catalogListAuthorities', options);

/**
 * List Authorities
 */
export const catalogListAuthoritiesOptions = (options?: Options<CatalogListAuthoritiesData>) => queryOptions<CatalogListAuthoritiesResponse, CatalogListAuthoritiesError, CatalogListAuthoritiesResponse, ReturnType<typeof catalogListAuthoritiesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await catalogListAuthorities({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: catalogListAuthoritiesQueryKey(options)
});

export const curvesListBandsQueryKey = (options: Options<CurvesListBandsData>) => createQueryKey('curvesListBands', options);

/**
 * List Bands
 */
export const curvesListBandsOptions = (options: Options<CurvesListBandsData>) => queryOptions<CurvesListBandsResponse, CurvesListBandsError, CurvesListBandsResponse, ReturnType<typeof curvesListBandsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await curvesListBands({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: curvesListBandsQueryKey(options)
});

export const curvesListBandsInfiniteQueryKey = (options: Options<CurvesListBandsData>): QueryKey<Options<CurvesListBandsData>> => createQueryKey('curvesListBands', options, true);

/**
 * List Bands
 */
export const curvesListBandsInfiniteOptions = (options: Options<CurvesListBandsData>) => {
    const opts = infiniteQueryOptions<CurvesListBandsResponse, CurvesListBandsError, InfiniteData<CurvesListBandsResponse>, QueryKey<Options<CurvesListBandsData>>, string | null | Pick<QueryKey<Options<CurvesListBandsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<CurvesListBandsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await curvesListBands({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: curvesListBandsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const capabilitiesListCapabilityDocumentsQueryKey = (options?: Options<CapabilitiesListCapabilityDocumentsData>) => createQueryKey('capabilitiesListCapabilityDocuments', options);

/**
 * List Capability Documents
 */
export const capabilitiesListCapabilityDocumentsOptions = (options?: Options<CapabilitiesListCapabilityDocumentsData>) => queryOptions<CapabilitiesListCapabilityDocumentsResponse, CapabilitiesListCapabilityDocumentsError, CapabilitiesListCapabilityDocumentsResponse, ReturnType<typeof capabilitiesListCapabilityDocumentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await capabilitiesListCapabilityDocuments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: capabilitiesListCapabilityDocumentsQueryKey(options)
});

/**
 * Create Capability Upload
 */
export const capabilitiesCreateCapabilityUploadMutation = (options?: Partial<Options<CapabilitiesCreateCapabilityUploadData>>): UseMutationOptions<CapabilitiesCreateCapabilityUploadResponse, CapabilitiesCreateCapabilityUploadError, Options<CapabilitiesCreateCapabilityUploadData>> => {
    const mutationOptions: UseMutationOptions<CapabilitiesCreateCapabilityUploadResponse, CapabilitiesCreateCapabilityUploadError, Options<CapabilitiesCreateCapabilityUploadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await capabilitiesCreateCapabilityUpload({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Capability Upload
 */
export const capabilitiesDeleteCapabilityUploadMutation = (options?: Partial<Options<CapabilitiesDeleteCapabilityUploadData>>): UseMutationOptions<CapabilitiesDeleteCapabilityUploadResponse, CapabilitiesDeleteCapabilityUploadError, Options<CapabilitiesDeleteCapabilityUploadData>> => {
    const mutationOptions: UseMutationOptions<CapabilitiesDeleteCapabilityUploadResponse, CapabilitiesDeleteCapabilityUploadError, Options<CapabilitiesDeleteCapabilityUploadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await capabilitiesDeleteCapabilityUpload({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const capabilitiesGetCapabilityUploadQueryKey = (options: Options<CapabilitiesGetCapabilityUploadData>) => createQueryKey('capabilitiesGetCapabilityUpload', options);

/**
 * Get Capability Upload
 */
export const capabilitiesGetCapabilityUploadOptions = (options: Options<CapabilitiesGetCapabilityUploadData>) => queryOptions<CapabilitiesGetCapabilityUploadResponse, CapabilitiesGetCapabilityUploadError, CapabilitiesGetCapabilityUploadResponse, ReturnType<typeof capabilitiesGetCapabilityUploadQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await capabilitiesGetCapabilityUpload({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: capabilitiesGetCapabilityUploadQueryKey(options)
});

/**
 * Complete Capability Upload
 */
export const capabilitiesCompleteCapabilityUploadMutation = (options?: Partial<Options<CapabilitiesCompleteCapabilityUploadData>>): UseMutationOptions<CapabilitiesCompleteCapabilityUploadResponse, CapabilitiesCompleteCapabilityUploadError, Options<CapabilitiesCompleteCapabilityUploadData>> => {
    const mutationOptions: UseMutationOptions<CapabilitiesCompleteCapabilityUploadResponse, CapabilitiesCompleteCapabilityUploadError, Options<CapabilitiesCompleteCapabilityUploadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await capabilitiesCompleteCapabilityUpload({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Put Capability Upload Part
 */
export const capabilitiesPutCapabilityUploadPartMutation = (options?: Partial<Options<CapabilitiesPutCapabilityUploadPartData>>): UseMutationOptions<CapabilitiesPutCapabilityUploadPartResponse, CapabilitiesPutCapabilityUploadPartError, Options<CapabilitiesPutCapabilityUploadPartData>> => {
    const mutationOptions: UseMutationOptions<CapabilitiesPutCapabilityUploadPartResponse, CapabilitiesPutCapabilityUploadPartError, Options<CapabilitiesPutCapabilityUploadPartData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await capabilitiesPutCapabilityUploadPart({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Capability Document
 */
export const capabilitiesDeleteCapabilityDocumentMutation = (options?: Partial<Options<CapabilitiesDeleteCapabilityDocumentData>>): UseMutationOptions<CapabilitiesDeleteCapabilityDocumentResponse, CapabilitiesDeleteCapabilityDocumentError, Options<CapabilitiesDeleteCapabilityDocumentData>> => {
    const mutationOptions: UseMutationOptions<CapabilitiesDeleteCapabilityDocumentResponse, CapabilitiesDeleteCapabilityDocumentError, Options<CapabilitiesDeleteCapabilityDocumentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await capabilitiesDeleteCapabilityDocument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const capabilitiesGetCapabilityDocumentQueryKey = (options: Options<CapabilitiesGetCapabilityDocumentData>) => createQueryKey('capabilitiesGetCapabilityDocument', options);

/**
 * Get Capability Document
 */
export const capabilitiesGetCapabilityDocumentOptions = (options: Options<CapabilitiesGetCapabilityDocumentData>) => queryOptions<CapabilitiesGetCapabilityDocumentResponse, CapabilitiesGetCapabilityDocumentError, CapabilitiesGetCapabilityDocumentResponse, ReturnType<typeof capabilitiesGetCapabilityDocumentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await capabilitiesGetCapabilityDocument({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: capabilitiesGetCapabilityDocumentQueryKey(options)
});

export const capabilitiesListCapabilitiesQueryKey = (options: Options<CapabilitiesListCapabilitiesData>) => createQueryKey('capabilitiesListCapabilities', options);

/**
 * List Capabilities
 */
export const capabilitiesListCapabilitiesOptions = (options: Options<CapabilitiesListCapabilitiesData>) => queryOptions<CapabilitiesListCapabilitiesResponse, CapabilitiesListCapabilitiesError, CapabilitiesListCapabilitiesResponse, ReturnType<typeof capabilitiesListCapabilitiesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await capabilitiesListCapabilities({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: capabilitiesListCapabilitiesQueryKey(options)
});

/**
 * Extract Capability Document
 */
export const capabilitiesExtractCapabilityDocumentMutation = (options?: Partial<Options<CapabilitiesExtractCapabilityDocumentData>>): UseMutationOptions<CapabilitiesExtractCapabilityDocumentResponse, CapabilitiesExtractCapabilityDocumentError, Options<CapabilitiesExtractCapabilityDocumentData>> => {
    const mutationOptions: UseMutationOptions<CapabilitiesExtractCapabilityDocumentResponse, CapabilitiesExtractCapabilityDocumentError, Options<CapabilitiesExtractCapabilityDocumentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await capabilitiesExtractCapabilityDocument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const capabilitiesGetCapabilityDocumentPdfQueryKey = (options: Options<CapabilitiesGetCapabilityDocumentPdfData>) => createQueryKey('capabilitiesGetCapabilityDocumentPdf', options);

/**
 * Get Capability Document Pdf
 */
export const capabilitiesGetCapabilityDocumentPdfOptions = (options: Options<CapabilitiesGetCapabilityDocumentPdfData>) => queryOptions<CapabilitiesGetCapabilityDocumentPdfResponse, CapabilitiesGetCapabilityDocumentPdfError, CapabilitiesGetCapabilityDocumentPdfResponse, ReturnType<typeof capabilitiesGetCapabilityDocumentPdfQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await capabilitiesGetCapabilityDocumentPdf({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: capabilitiesGetCapabilityDocumentPdfQueryKey(options)
});

export const clausesListClausesQueryKey = (options: Options<ClausesListClausesData>) => createQueryKey('clausesListClauses', options);

/**
 * List Clauses
 */
export const clausesListClausesOptions = (options: Options<ClausesListClausesData>) => queryOptions<ClausesListClausesResponse, ClausesListClausesError, ClausesListClausesResponse, ReturnType<typeof clausesListClausesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await clausesListClauses({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: clausesListClausesQueryKey(options)
});

export const clausesListClausesInfiniteQueryKey = (options: Options<ClausesListClausesData>): QueryKey<Options<ClausesListClausesData>> => createQueryKey('clausesListClauses', options, true);

/**
 * List Clauses
 */
export const clausesListClausesInfiniteOptions = (options: Options<ClausesListClausesData>) => {
    const opts = infiniteQueryOptions<ClausesListClausesResponse, ClausesListClausesError, InfiniteData<ClausesListClausesResponse>, QueryKey<Options<ClausesListClausesData>>, string | null | Pick<QueryKey<Options<ClausesListClausesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ClausesListClausesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await clausesListClauses({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: clausesListClausesInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const clausesGetClauseQueryKey = (options: Options<ClausesGetClauseData>) => createQueryKey('clausesGetClause', options);

/**
 * Get Clause
 */
export const clausesGetClauseOptions = (options: Options<ClausesGetClauseData>) => queryOptions<ClausesGetClauseResponse, ClausesGetClauseError, ClausesGetClauseResponse, ReturnType<typeof clausesGetClauseQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await clausesGetClause({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: clausesGetClauseQueryKey(options)
});

export const curvesListCurvesQueryKey = (options: Options<CurvesListCurvesData>) => createQueryKey('curvesListCurves', options);

/**
 * List Curves
 */
export const curvesListCurvesOptions = (options: Options<CurvesListCurvesData>) => queryOptions<CurvesListCurvesResponse, CurvesListCurvesError, CurvesListCurvesResponse, ReturnType<typeof curvesListCurvesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await curvesListCurves({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: curvesListCurvesQueryKey(options)
});

export const curvesListCurvesInfiniteQueryKey = (options: Options<CurvesListCurvesData>): QueryKey<Options<CurvesListCurvesData>> => createQueryKey('curvesListCurves', options, true);

/**
 * List Curves
 */
export const curvesListCurvesInfiniteOptions = (options: Options<CurvesListCurvesData>) => {
    const opts = infiniteQueryOptions<CurvesListCurvesResponse, CurvesListCurvesError, InfiniteData<CurvesListCurvesResponse>, QueryKey<Options<CurvesListCurvesData>>, string | null | Pick<QueryKey<Options<CurvesListCurvesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<CurvesListCurvesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await curvesListCurves({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: curvesListCurvesInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const curvesGetCurveFacetsQueryKey = (options: Options<CurvesGetCurveFacetsData>) => createQueryKey('curvesGetCurveFacets', options);

/**
 * Get Curve Facets
 */
export const curvesGetCurveFacetsOptions = (options: Options<CurvesGetCurveFacetsData>) => queryOptions<CurvesGetCurveFacetsResponse, CurvesGetCurveFacetsError, CurvesGetCurveFacetsResponse, ReturnType<typeof curvesGetCurveFacetsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await curvesGetCurveFacets({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: curvesGetCurveFacetsQueryKey(options)
});

export const curvesGetCurveQueryKey = (options: Options<CurvesGetCurveData>) => createQueryKey('curvesGetCurve', options);

/**
 * Get Curve
 */
export const curvesGetCurveOptions = (options: Options<CurvesGetCurveData>) => queryOptions<CurvesGetCurveResponse, CurvesGetCurveError, CurvesGetCurveResponse, ReturnType<typeof curvesGetCurveQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await curvesGetCurve({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: curvesGetCurveQueryKey(options)
});

export const vocabularyListDefinitionsQueryKey = (options: Options<VocabularyListDefinitionsData>) => createQueryKey('vocabularyListDefinitions', options);

/**
 * List Definitions
 */
export const vocabularyListDefinitionsOptions = (options: Options<VocabularyListDefinitionsData>) => queryOptions<VocabularyListDefinitionsResponse, VocabularyListDefinitionsError, VocabularyListDefinitionsResponse, ReturnType<typeof vocabularyListDefinitionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await vocabularyListDefinitions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: vocabularyListDefinitionsQueryKey(options)
});

export const vocabularyListDefinitionsInfiniteQueryKey = (options: Options<VocabularyListDefinitionsData>): QueryKey<Options<VocabularyListDefinitionsData>> => createQueryKey('vocabularyListDefinitions', options, true);

/**
 * List Definitions
 */
export const vocabularyListDefinitionsInfiniteOptions = (options: Options<VocabularyListDefinitionsData>) => {
    const opts = infiniteQueryOptions<VocabularyListDefinitionsResponse, VocabularyListDefinitionsError, InfiniteData<VocabularyListDefinitionsResponse>, QueryKey<Options<VocabularyListDefinitionsData>>, string | null | Pick<QueryKey<Options<VocabularyListDefinitionsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<VocabularyListDefinitionsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await vocabularyListDefinitions({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: vocabularyListDefinitionsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const vocabularyLookupDefinitionQueryKey = (options: Options<VocabularyLookupDefinitionData>) => createQueryKey('vocabularyLookupDefinition', options);

/**
 * Lookup Definition
 */
export const vocabularyLookupDefinitionOptions = (options: Options<VocabularyLookupDefinitionData>) => queryOptions<VocabularyLookupDefinitionResponse, VocabularyLookupDefinitionError, VocabularyLookupDefinitionResponse, ReturnType<typeof vocabularyLookupDefinitionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await vocabularyLookupDefinition({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: vocabularyLookupDefinitionQueryKey(options)
});

export const vocabularyGetDefinitionQueryKey = (options: Options<VocabularyGetDefinitionData>) => createQueryKey('vocabularyGetDefinition', options);

/**
 * Get Definition
 */
export const vocabularyGetDefinitionOptions = (options: Options<VocabularyGetDefinitionData>) => queryOptions<VocabularyGetDefinitionResponse, VocabularyGetDefinitionError, VocabularyGetDefinitionResponse, ReturnType<typeof vocabularyGetDefinitionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await vocabularyGetDefinition({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: vocabularyGetDefinitionQueryKey(options)
});

export const catalogListDocumentsQueryKey = (options?: Options<CatalogListDocumentsData>) => createQueryKey('catalogListDocuments', options);

/**
 * List Documents
 */
export const catalogListDocumentsOptions = (options?: Options<CatalogListDocumentsData>) => queryOptions<CatalogListDocumentsResponse, CatalogListDocumentsError, CatalogListDocumentsResponse, ReturnType<typeof catalogListDocumentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await catalogListDocuments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: catalogListDocumentsQueryKey(options)
});

export const catalogGetDocumentQueryKey = (options: Options<CatalogGetDocumentData>) => createQueryKey('catalogGetDocument', options);

/**
 * Get Document
 */
export const catalogGetDocumentOptions = (options: Options<CatalogGetDocumentData>) => queryOptions<CatalogGetDocumentResponse, CatalogGetDocumentError, CatalogGetDocumentResponse, ReturnType<typeof catalogGetDocumentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await catalogGetDocument({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: catalogGetDocumentQueryKey(options)
});

export const operationsGetDocumentAuditQueryKey = (options: Options<OperationsGetDocumentAuditData>) => createQueryKey('operationsGetDocumentAudit', options);

/**
 * Get Document Audit
 */
export const operationsGetDocumentAuditOptions = (options: Options<OperationsGetDocumentAuditData>) => queryOptions<OperationsGetDocumentAuditResponse, OperationsGetDocumentAuditError, OperationsGetDocumentAuditResponse, ReturnType<typeof operationsGetDocumentAuditQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await operationsGetDocumentAudit({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: operationsGetDocumentAuditQueryKey(options)
});

export const curvesListChartsQueryKey = (options: Options<CurvesListChartsData>) => createQueryKey('curvesListCharts', options);

/**
 * List Charts
 */
export const curvesListChartsOptions = (options: Options<CurvesListChartsData>) => queryOptions<CurvesListChartsResponse, CurvesListChartsError, CurvesListChartsResponse, ReturnType<typeof curvesListChartsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await curvesListCharts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: curvesListChartsQueryKey(options)
});

export const curvesGetChartQueryKey = (options: Options<CurvesGetChartData>) => createQueryKey('curvesGetChart', options);

/**
 * Get Chart
 */
export const curvesGetChartOptions = (options: Options<CurvesGetChartData>) => queryOptions<CurvesGetChartResponse, CurvesGetChartError, CurvesGetChartResponse, ReturnType<typeof curvesGetChartQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await curvesGetChart({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: curvesGetChartQueryKey(options)
});

export const operationsListCompletenessGapsQueryKey = (options: Options<OperationsListCompletenessGapsData>) => createQueryKey('operationsListCompletenessGaps', options);

/**
 * List Completeness Gaps
 */
export const operationsListCompletenessGapsOptions = (options: Options<OperationsListCompletenessGapsData>) => queryOptions<OperationsListCompletenessGapsResponse, OperationsListCompletenessGapsError, OperationsListCompletenessGapsResponse, ReturnType<typeof operationsListCompletenessGapsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await operationsListCompletenessGaps({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: operationsListCompletenessGapsQueryKey(options)
});

export const operationsGetConfidenceHistogramQueryKey = (options: Options<OperationsGetConfidenceHistogramData>) => createQueryKey('operationsGetConfidenceHistogram', options);

/**
 * Get Confidence Histogram
 */
export const operationsGetConfidenceHistogramOptions = (options: Options<OperationsGetConfidenceHistogramData>) => queryOptions<OperationsGetConfidenceHistogramResponse, OperationsGetConfidenceHistogramError, OperationsGetConfidenceHistogramResponse, ReturnType<typeof operationsGetConfidenceHistogramQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await operationsGetConfidenceHistogram({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: operationsGetConfidenceHistogramQueryKey(options)
});

export const catalogListFiguresQueryKey = (options: Options<CatalogListFiguresData>) => createQueryKey('catalogListFigures', options);

/**
 * List Figures
 */
export const catalogListFiguresOptions = (options: Options<CatalogListFiguresData>) => queryOptions<CatalogListFiguresResponse, CatalogListFiguresError, CatalogListFiguresResponse, ReturnType<typeof catalogListFiguresQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await catalogListFigures({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: catalogListFiguresQueryKey(options)
});

export const catalogListFiguresInfiniteQueryKey = (options: Options<CatalogListFiguresData>): QueryKey<Options<CatalogListFiguresData>> => createQueryKey('catalogListFigures', options, true);

/**
 * List Figures
 */
export const catalogListFiguresInfiniteOptions = (options: Options<CatalogListFiguresData>) => {
    const opts = infiniteQueryOptions<CatalogListFiguresResponse, CatalogListFiguresError, InfiniteData<CatalogListFiguresResponse>, QueryKey<Options<CatalogListFiguresData>>, string | null | Pick<QueryKey<Options<CatalogListFiguresData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<CatalogListFiguresData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await catalogListFigures({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: catalogListFiguresInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const sourcesGetFigureImageQueryKey = (options: Options<SourcesGetFigureImageData>) => createQueryKey('sourcesGetFigureImage', options);

/**
 * Get Figure Image
 */
export const sourcesGetFigureImageOptions = (options: Options<SourcesGetFigureImageData>) => queryOptions<SourcesGetFigureImageResponse, SourcesGetFigureImageError, SourcesGetFigureImageResponse, ReturnType<typeof sourcesGetFigureImageQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await sourcesGetFigureImage({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: sourcesGetFigureImageQueryKey(options)
});

export const operationsGetDocumentIntegrityQueryKey = (options: Options<OperationsGetDocumentIntegrityData>) => createQueryKey('operationsGetDocumentIntegrity', options);

/**
 * Get Document Integrity
 */
export const operationsGetDocumentIntegrityOptions = (options: Options<OperationsGetDocumentIntegrityData>) => queryOptions<OperationsGetDocumentIntegrityResponse, OperationsGetDocumentIntegrityError, OperationsGetDocumentIntegrityResponse, ReturnType<typeof operationsGetDocumentIntegrityQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await operationsGetDocumentIntegrity({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: operationsGetDocumentIntegrityQueryKey(options)
});

export const clausesListPageClausesQueryKey = (options: Options<ClausesListPageClausesData>) => createQueryKey('clausesListPageClauses', options);

/**
 * List Page Clauses
 */
export const clausesListPageClausesOptions = (options: Options<ClausesListPageClausesData>) => queryOptions<ClausesListPageClausesResponse, ClausesListPageClausesError, ClausesListPageClausesResponse, ReturnType<typeof clausesListPageClausesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await clausesListPageClauses({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: clausesListPageClausesQueryKey(options)
});

export const clausesListPageClausesInfiniteQueryKey = (options: Options<ClausesListPageClausesData>): QueryKey<Options<ClausesListPageClausesData>> => createQueryKey('clausesListPageClauses', options, true);

/**
 * List Page Clauses
 */
export const clausesListPageClausesInfiniteOptions = (options: Options<ClausesListPageClausesData>) => {
    const opts = infiniteQueryOptions<ClausesListPageClausesResponse, ClausesListPageClausesError, InfiniteData<ClausesListPageClausesResponse>, QueryKey<Options<ClausesListPageClausesData>>, number | Pick<QueryKey<Options<ClausesListPageClausesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ClausesListPageClausesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                path: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await clausesListPageClauses({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: clausesListPageClausesInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const sourcesGetPageHighlightsQueryKey = (options: Options<SourcesGetPageHighlightsData>) => createQueryKey('sourcesGetPageHighlights', options);

/**
 * Get Page Highlights
 */
export const sourcesGetPageHighlightsOptions = (options: Options<SourcesGetPageHighlightsData>) => queryOptions<SourcesGetPageHighlightsResponse, SourcesGetPageHighlightsError, SourcesGetPageHighlightsResponse, ReturnType<typeof sourcesGetPageHighlightsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await sourcesGetPageHighlights({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: sourcesGetPageHighlightsQueryKey(options)
});

export const sourcesGetPageHighlightsInfiniteQueryKey = (options: Options<SourcesGetPageHighlightsData>): QueryKey<Options<SourcesGetPageHighlightsData>> => createQueryKey('sourcesGetPageHighlights', options, true);

/**
 * Get Page Highlights
 */
export const sourcesGetPageHighlightsInfiniteOptions = (options: Options<SourcesGetPageHighlightsData>) => {
    const opts = infiniteQueryOptions<SourcesGetPageHighlightsResponse, SourcesGetPageHighlightsError, InfiniteData<SourcesGetPageHighlightsResponse>, QueryKey<Options<SourcesGetPageHighlightsData>>, number | Pick<QueryKey<Options<SourcesGetPageHighlightsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<SourcesGetPageHighlightsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                path: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await sourcesGetPageHighlights({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: sourcesGetPageHighlightsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Locate Texts
 */
export const sourcesLocateTextsMutation = (options?: Partial<Options<SourcesLocateTextsData>>): UseMutationOptions<SourcesLocateTextsResponse, SourcesLocateTextsError, Options<SourcesLocateTextsData>> => {
    const mutationOptions: UseMutationOptions<SourcesLocateTextsResponse, SourcesLocateTextsError, Options<SourcesLocateTextsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await sourcesLocateTexts({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const sourcesGetDocumentPdfQueryKey = (options: Options<SourcesGetDocumentPdfData>) => createQueryKey('sourcesGetDocumentPdf', options);

/**
 * Get Document Pdf
 */
export const sourcesGetDocumentPdfOptions = (options: Options<SourcesGetDocumentPdfData>) => queryOptions<SourcesGetDocumentPdfResponse, SourcesGetDocumentPdfError, SourcesGetDocumentPdfResponse, ReturnType<typeof sourcesGetDocumentPdfQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await sourcesGetDocumentPdf({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: sourcesGetDocumentPdfQueryKey(options)
});

/**
 * Promote Document
 */
export const lifecyclePromoteDocumentMutation = (options?: Partial<Options<LifecyclePromoteDocumentData>>): UseMutationOptions<LifecyclePromoteDocumentResponse, LifecyclePromoteDocumentError, Options<LifecyclePromoteDocumentData>> => {
    const mutationOptions: UseMutationOptions<LifecyclePromoteDocumentResponse, LifecyclePromoteDocumentError, Options<LifecyclePromoteDocumentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await lifecyclePromoteDocument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const catalogListStandardsQueryKey = (options: Options<CatalogListStandardsData>) => createQueryKey('catalogListStandards', options);

/**
 * List Standards
 */
export const catalogListStandardsOptions = (options: Options<CatalogListStandardsData>) => queryOptions<CatalogListStandardsResponse, CatalogListStandardsError, CatalogListStandardsResponse, ReturnType<typeof catalogListStandardsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await catalogListStandards({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: catalogListStandardsQueryKey(options)
});

export const catalogGetDocumentStatsQueryKey = (options: Options<CatalogGetDocumentStatsData>) => createQueryKey('catalogGetDocumentStats', options);

/**
 * Get Document Stats
 */
export const catalogGetDocumentStatsOptions = (options: Options<CatalogGetDocumentStatsData>) => queryOptions<CatalogGetDocumentStatsResponse, CatalogGetDocumentStatsError, CatalogGetDocumentStatsResponse, ReturnType<typeof catalogGetDocumentStatsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await catalogGetDocumentStats({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: catalogGetDocumentStatsQueryKey(options)
});

/**
 * Set Document Status
 */
export const lifecycleSetDocumentStatusMutation = (options?: Partial<Options<LifecycleSetDocumentStatusData>>): UseMutationOptions<LifecycleSetDocumentStatusResponse, LifecycleSetDocumentStatusError, Options<LifecycleSetDocumentStatusData>> => {
    const mutationOptions: UseMutationOptions<LifecycleSetDocumentStatusResponse, LifecycleSetDocumentStatusError, Options<LifecycleSetDocumentStatusData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await lifecycleSetDocumentStatus({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const catalogListTablesQueryKey = (options: Options<CatalogListTablesData>) => createQueryKey('catalogListTables', options);

/**
 * List Tables
 */
export const catalogListTablesOptions = (options: Options<CatalogListTablesData>) => queryOptions<CatalogListTablesResponse, CatalogListTablesError, CatalogListTablesResponse, ReturnType<typeof catalogListTablesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await catalogListTables({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: catalogListTablesQueryKey(options)
});

export const catalogListTablesInfiniteQueryKey = (options: Options<CatalogListTablesData>): QueryKey<Options<CatalogListTablesData>> => createQueryKey('catalogListTables', options, true);

/**
 * List Tables
 */
export const catalogListTablesInfiniteOptions = (options: Options<CatalogListTablesData>) => {
    const opts = infiniteQueryOptions<CatalogListTablesResponse, CatalogListTablesError, InfiniteData<CatalogListTablesResponse>, QueryKey<Options<CatalogListTablesData>>, string | null | Pick<QueryKey<Options<CatalogListTablesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<CatalogListTablesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await catalogListTables({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: catalogListTablesInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const catalogGetTableQueryKey = (options: Options<CatalogGetTableData>) => createQueryKey('catalogGetTable', options);

/**
 * Get Table
 */
export const catalogGetTableOptions = (options: Options<CatalogGetTableData>) => queryOptions<CatalogGetTableResponse, CatalogGetTableError, CatalogGetTableResponse, ReturnType<typeof catalogGetTableQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await catalogGetTable({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: catalogGetTableQueryKey(options)
});

export const catalogListThresholdsQueryKey = (options: Options<CatalogListThresholdsData>) => createQueryKey('catalogListThresholds', options);

/**
 * List Thresholds
 */
export const catalogListThresholdsOptions = (options: Options<CatalogListThresholdsData>) => queryOptions<CatalogListThresholdsResponse, CatalogListThresholdsError, CatalogListThresholdsResponse, ReturnType<typeof catalogListThresholdsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await catalogListThresholds({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: catalogListThresholdsQueryKey(options)
});

export const clausesGetTocQueryKey = (options: Options<ClausesGetTocData>) => createQueryKey('clausesGetToc', options);

/**
 * Get Toc
 */
export const clausesGetTocOptions = (options: Options<ClausesGetTocData>) => queryOptions<ClausesGetTocResponse, ClausesGetTocError, ClausesGetTocResponse, ReturnType<typeof clausesGetTocQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await clausesGetToc({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: clausesGetTocQueryKey(options)
});

export const operationsListEvaluationsQueryKey = (options?: Options<OperationsListEvaluationsData>) => createQueryKey('operationsListEvaluations', options);

/**
 * List Evaluations
 */
export const operationsListEvaluationsOptions = (options?: Options<OperationsListEvaluationsData>) => queryOptions<OperationsListEvaluationsResponse, OperationsListEvaluationsError, OperationsListEvaluationsResponse, ReturnType<typeof operationsListEvaluationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await operationsListEvaluations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: operationsListEvaluationsQueryKey(options)
});

export const exportsExportRequirementsCsvQueryKey = (options: Options<ExportsExportRequirementsCsvData>) => createQueryKey('exportsExportRequirementsCsv', options);

/**
 * Export Requirements Csv
 */
export const exportsExportRequirementsCsvOptions = (options: Options<ExportsExportRequirementsCsvData>) => queryOptions<ExportsExportRequirementsCsvResponse, ExportsExportRequirementsCsvError, ExportsExportRequirementsCsvResponse, ReturnType<typeof exportsExportRequirementsCsvQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await exportsExportRequirementsCsv({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: exportsExportRequirementsCsvQueryKey(options)
});

export const exportsExportRequirementsXlsxQueryKey = (options: Options<ExportsExportRequirementsXlsxData>) => createQueryKey('exportsExportRequirementsXlsx', options);

/**
 * Export Requirements Xlsx
 */
export const exportsExportRequirementsXlsxOptions = (options: Options<ExportsExportRequirementsXlsxData>) => queryOptions<ExportsExportRequirementsXlsxResponse, ExportsExportRequirementsXlsxError, ExportsExportRequirementsXlsxResponse, ReturnType<typeof exportsExportRequirementsXlsxQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await exportsExportRequirementsXlsx({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: exportsExportRequirementsXlsxQueryKey(options)
});

export const catalogListFamiliesQueryKey = (options?: Options<CatalogListFamiliesData>) => createQueryKey('catalogListFamilies', options);

/**
 * List Families
 */
export const catalogListFamiliesOptions = (options?: Options<CatalogListFamiliesData>) => queryOptions<CatalogListFamiliesResponse, CatalogListFamiliesError, CatalogListFamiliesResponse, ReturnType<typeof catalogListFamiliesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await catalogListFamilies({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: catalogListFamiliesQueryKey(options)
});

export const catalogGetCurrentDocumentQueryKey = (options: Options<CatalogGetCurrentDocumentData>) => createQueryKey('catalogGetCurrentDocument', options);

/**
 * Get Current Document
 */
export const catalogGetCurrentDocumentOptions = (options: Options<CatalogGetCurrentDocumentData>) => queryOptions<CatalogGetCurrentDocumentResponse, CatalogGetCurrentDocumentError, CatalogGetCurrentDocumentResponse, ReturnType<typeof catalogGetCurrentDocumentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await catalogGetCurrentDocument({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: catalogGetCurrentDocumentQueryKey(options)
});

export const lifecycleListFamilyVersionsQueryKey = (options: Options<LifecycleListFamilyVersionsData>) => createQueryKey('lifecycleListFamilyVersions', options);

/**
 * List Family Versions
 */
export const lifecycleListFamilyVersionsOptions = (options: Options<LifecycleListFamilyVersionsData>) => queryOptions<LifecycleListFamilyVersionsResponse, LifecycleListFamilyVersionsError, LifecycleListFamilyVersionsResponse, ReturnType<typeof lifecycleListFamilyVersionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await lifecycleListFamilyVersions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: lifecycleListFamilyVersionsQueryKey(options)
});

/**
 * Send Feedback
 */
export const feedbackSendFeedbackMutation = (options?: Partial<Options<FeedbackSendFeedbackData>>): UseMutationOptions<FeedbackSendFeedbackResponse, FeedbackSendFeedbackError, Options<FeedbackSendFeedbackData>> => {
    const mutationOptions: UseMutationOptions<FeedbackSendFeedbackResponse, FeedbackSendFeedbackError, Options<FeedbackSendFeedbackData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await feedbackSendFeedback({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const jobsListJobsQueryKey = (options?: Options<JobsListJobsData>) => createQueryKey('jobsListJobs', options);

/**
 * List Jobs
 */
export const jobsListJobsOptions = (options?: Options<JobsListJobsData>) => queryOptions<JobsListJobsResponse, JobsListJobsError, JobsListJobsResponse, ReturnType<typeof jobsListJobsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await jobsListJobs({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: jobsListJobsQueryKey(options)
});

/**
 * Create Job
 */
export const jobsCreateJobMutation = (options?: Partial<Options<JobsCreateJobData>>): UseMutationOptions<JobsCreateJobResponse, JobsCreateJobError, Options<JobsCreateJobData>> => {
    const mutationOptions: UseMutationOptions<JobsCreateJobResponse, JobsCreateJobError, Options<JobsCreateJobData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await jobsCreateJob({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const jobsGetActiveJobCountQueryKey = (options?: Options<JobsGetActiveJobCountData>) => createQueryKey('jobsGetActiveJobCount', options);

/**
 * Get Active Job Count
 */
export const jobsGetActiveJobCountOptions = (options?: Options<JobsGetActiveJobCountData>) => queryOptions<JobsGetActiveJobCountResponse, JobsGetActiveJobCountError, JobsGetActiveJobCountResponse, ReturnType<typeof jobsGetActiveJobCountQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await jobsGetActiveJobCount({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: jobsGetActiveJobCountQueryKey(options)
});

export const jobsGetJobCapacityQueryKey = (options?: Options<JobsGetJobCapacityData>) => createQueryKey('jobsGetJobCapacity', options);

/**
 * Get Job Capacity
 */
export const jobsGetJobCapacityOptions = (options?: Options<JobsGetJobCapacityData>) => queryOptions<JobsGetJobCapacityResponse, JobsGetJobCapacityError, JobsGetJobCapacityResponse, ReturnType<typeof jobsGetJobCapacityQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await jobsGetJobCapacity({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: jobsGetJobCapacityQueryKey(options)
});

export const jobsGetJobEstimateQueryKey = (options: Options<JobsGetJobEstimateData>) => createQueryKey('jobsGetJobEstimate', options);

/**
 * Get Job Estimate
 */
export const jobsGetJobEstimateOptions = (options: Options<JobsGetJobEstimateData>) => queryOptions<JobsGetJobEstimateResponse, JobsGetJobEstimateError, JobsGetJobEstimateResponse, ReturnType<typeof jobsGetJobEstimateQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await jobsGetJobEstimate({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: jobsGetJobEstimateQueryKey(options)
});

export const jobsGetJobQueryKey = (options: Options<JobsGetJobData>) => createQueryKey('jobsGetJob', options);

/**
 * Get Job
 */
export const jobsGetJobOptions = (options: Options<JobsGetJobData>) => queryOptions<JobsGetJobResponse, JobsGetJobError, JobsGetJobResponse, ReturnType<typeof jobsGetJobQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await jobsGetJob({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: jobsGetJobQueryKey(options)
});

/**
 * Cancel Job
 */
export const jobsCancelJobMutation = (options?: Partial<Options<JobsCancelJobData>>): UseMutationOptions<JobsCancelJobResponse, JobsCancelJobError, Options<JobsCancelJobData>> => {
    const mutationOptions: UseMutationOptions<JobsCancelJobResponse, JobsCancelJobError, Options<JobsCancelJobData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await jobsCancelJob({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const metaListJurisdictionsQueryKey = (options?: Options<MetaListJurisdictionsData>) => createQueryKey('metaListJurisdictions', options);

/**
 * List Jurisdictions
 */
export const metaListJurisdictionsOptions = (options?: Options<MetaListJurisdictionsData>) => queryOptions<MetaListJurisdictionsResponse, MetaListJurisdictionsError, MetaListJurisdictionsResponse, ReturnType<typeof metaListJurisdictionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await metaListJurisdictions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: metaListJurisdictionsQueryKey(options)
});

export const metaGetMeQueryKey = (options?: Options<MetaGetMeData>) => createQueryKey('metaGetMe', options);

/**
 * Get Me
 */
export const metaGetMeOptions = (options?: Options<MetaGetMeData>) => queryOptions<MetaGetMeResponse, MetaGetMeError, MetaGetMeResponse, ReturnType<typeof metaGetMeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await metaGetMe({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: metaGetMeQueryKey(options)
});

export const whatsNewListEntriesQueryKey = (options?: Options<WhatsNewListEntriesData>) => createQueryKey('whatsNewListEntries', options);

/**
 * List Entries
 */
export const whatsNewListEntriesOptions = (options?: Options<WhatsNewListEntriesData>) => queryOptions<WhatsNewListEntriesResponse, WhatsNewListEntriesError, WhatsNewListEntriesResponse, ReturnType<typeof whatsNewListEntriesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await whatsNewListEntries({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: whatsNewListEntriesQueryKey(options)
});

/**
 * Mark Seen
 */
export const whatsNewMarkSeenMutation = (options?: Partial<Options<WhatsNewMarkSeenData>>): UseMutationOptions<WhatsNewMarkSeenResponse, WhatsNewMarkSeenError, Options<WhatsNewMarkSeenData>> => {
    const mutationOptions: UseMutationOptions<WhatsNewMarkSeenResponse, WhatsNewMarkSeenError, Options<WhatsNewMarkSeenData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await whatsNewMarkSeen({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const metaGetMetaQueryKey = (options?: Options<MetaGetMetaData>) => createQueryKey('metaGetMeta', options);

/**
 * Get Meta
 */
export const metaGetMetaOptions = (options?: Options<MetaGetMetaData>) => queryOptions<MetaGetMetaResponse, MetaGetMetaError, MetaGetMetaResponse, ReturnType<typeof metaGetMetaQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await metaGetMeta({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: metaGetMetaQueryKey(options)
});

export const vocabularyListParameterGroupsQueryKey = (options?: Options<VocabularyListParameterGroupsData>) => createQueryKey('vocabularyListParameterGroups', options);

/**
 * List Parameter Groups
 */
export const vocabularyListParameterGroupsOptions = (options?: Options<VocabularyListParameterGroupsData>) => queryOptions<VocabularyListParameterGroupsResponse, VocabularyListParameterGroupsError, VocabularyListParameterGroupsResponse, ReturnType<typeof vocabularyListParameterGroupsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await vocabularyListParameterGroups({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: vocabularyListParameterGroupsQueryKey(options)
});

export const vocabularyListParametersQueryKey = (options?: Options<VocabularyListParametersData>) => createQueryKey('vocabularyListParameters', options);

/**
 * List Parameters
 */
export const vocabularyListParametersOptions = (options?: Options<VocabularyListParametersData>) => queryOptions<VocabularyListParametersResponse, VocabularyListParametersError, VocabularyListParametersResponse, ReturnType<typeof vocabularyListParametersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await vocabularyListParameters({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: vocabularyListParametersQueryKey(options)
});

export const vocabularyListParametersInfiniteQueryKey = (options?: Options<VocabularyListParametersData>): QueryKey<Options<VocabularyListParametersData>> => createQueryKey('vocabularyListParameters', options, true);

/**
 * List Parameters
 */
export const vocabularyListParametersInfiniteOptions = (options?: Options<VocabularyListParametersData>) => {
    const opts = infiniteQueryOptions<VocabularyListParametersResponse, VocabularyListParametersError, InfiniteData<VocabularyListParametersResponse>, QueryKey<Options<VocabularyListParametersData>>, string | null | Pick<QueryKey<Options<VocabularyListParametersData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<VocabularyListParametersData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await vocabularyListParameters({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: vocabularyListParametersInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const vocabularyGetParameterQueryKey = (options: Options<VocabularyGetParameterData>) => createQueryKey('vocabularyGetParameter', options);

/**
 * Get Parameter
 */
export const vocabularyGetParameterOptions = (options: Options<VocabularyGetParameterData>) => queryOptions<VocabularyGetParameterResponse, VocabularyGetParameterError, VocabularyGetParameterResponse, ReturnType<typeof vocabularyGetParameterQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await vocabularyGetParameter({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: vocabularyGetParameterQueryKey(options)
});

export const vocabularyListParameterMarketsQueryKey = (options: Options<VocabularyListParameterMarketsData>) => createQueryKey('vocabularyListParameterMarkets', options);

/**
 * List Parameter Markets
 */
export const vocabularyListParameterMarketsOptions = (options: Options<VocabularyListParameterMarketsData>) => queryOptions<VocabularyListParameterMarketsResponse, VocabularyListParameterMarketsError, VocabularyListParameterMarketsResponse, ReturnType<typeof vocabularyListParameterMarketsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await vocabularyListParameterMarkets({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: vocabularyListParameterMarketsQueryKey(options)
});

export const requirementsListRequirementsQueryKey = (options: Options<RequirementsListRequirementsData>) => createQueryKey('requirementsListRequirements', options);

/**
 * List Requirements
 */
export const requirementsListRequirementsOptions = (options: Options<RequirementsListRequirementsData>) => queryOptions<RequirementsListRequirementsResponse, RequirementsListRequirementsError, RequirementsListRequirementsResponse, ReturnType<typeof requirementsListRequirementsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await requirementsListRequirements({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: requirementsListRequirementsQueryKey(options)
});

export const requirementsListRequirementsInfiniteQueryKey = (options: Options<RequirementsListRequirementsData>): QueryKey<Options<RequirementsListRequirementsData>> => createQueryKey('requirementsListRequirements', options, true);

/**
 * List Requirements
 */
export const requirementsListRequirementsInfiniteOptions = (options: Options<RequirementsListRequirementsData>) => {
    const opts = infiniteQueryOptions<RequirementsListRequirementsResponse, RequirementsListRequirementsError, InfiniteData<RequirementsListRequirementsResponse>, QueryKey<Options<RequirementsListRequirementsData>>, string | null | Pick<QueryKey<Options<RequirementsListRequirementsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<RequirementsListRequirementsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await requirementsListRequirements({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: requirementsListRequirementsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const requirementsGetRequirementFacetsQueryKey = (options: Options<RequirementsGetRequirementFacetsData>) => createQueryKey('requirementsGetRequirementFacets', options);

/**
 * Get Requirement Facets
 */
export const requirementsGetRequirementFacetsOptions = (options: Options<RequirementsGetRequirementFacetsData>) => queryOptions<RequirementsGetRequirementFacetsResponse, RequirementsGetRequirementFacetsError, RequirementsGetRequirementFacetsResponse, ReturnType<typeof requirementsGetRequirementFacetsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await requirementsGetRequirementFacets({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: requirementsGetRequirementFacetsQueryKey(options)
});

export const requirementsGetRequirementQueryKey = (options: Options<RequirementsGetRequirementData>) => createQueryKey('requirementsGetRequirement', options);

/**
 * Get Requirement
 */
export const requirementsGetRequirementOptions = (options: Options<RequirementsGetRequirementData>) => queryOptions<RequirementsGetRequirementResponse, RequirementsGetRequirementError, RequirementsGetRequirementResponse, ReturnType<typeof requirementsGetRequirementQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await requirementsGetRequirement({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: requirementsGetRequirementQueryKey(options)
});

export const operationsListRunsQueryKey = (options?: Options<OperationsListRunsData>) => createQueryKey('operationsListRuns', options);

/**
 * List Runs
 */
export const operationsListRunsOptions = (options?: Options<OperationsListRunsData>) => queryOptions<OperationsListRunsResponse, OperationsListRunsError, OperationsListRunsResponse, ReturnType<typeof operationsListRunsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await operationsListRuns({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: operationsListRunsQueryKey(options)
});

export const operationsGetRunQueryKey = (options: Options<OperationsGetRunData>) => createQueryKey('operationsGetRun', options);

/**
 * Get Run
 */
export const operationsGetRunOptions = (options: Options<OperationsGetRunData>) => queryOptions<OperationsGetRunResponse, OperationsGetRunError, OperationsGetRunResponse, ReturnType<typeof operationsGetRunQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await operationsGetRun({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: operationsGetRunQueryKey(options)
});

export const operationsGetRunReportQueryKey = (options: Options<OperationsGetRunReportData>) => createQueryKey('operationsGetRunReport', options);

/**
 * Get Run Report
 */
export const operationsGetRunReportOptions = (options: Options<OperationsGetRunReportData>) => queryOptions<OperationsGetRunReportResponse, OperationsGetRunReportError, OperationsGetRunReportResponse, ReturnType<typeof operationsGetRunReportQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await operationsGetRunReport({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: operationsGetRunReportQueryKey(options)
});

export const jobsGetRollbackImpactQueryKey = (options: Options<JobsGetRollbackImpactData>) => createQueryKey('jobsGetRollbackImpact', options);

/**
 * Get Rollback Impact
 */
export const jobsGetRollbackImpactOptions = (options: Options<JobsGetRollbackImpactData>) => queryOptions<JobsGetRollbackImpactResponse, JobsGetRollbackImpactError, JobsGetRollbackImpactResponse, ReturnType<typeof jobsGetRollbackImpactQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await jobsGetRollbackImpact({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: jobsGetRollbackImpactQueryKey(options)
});

export const searchSearchClausesQueryKey = (options: Options<SearchSearchClausesData>) => createQueryKey('searchSearchClauses', options);

/**
 * Search Clauses
 */
export const searchSearchClausesOptions = (options: Options<SearchSearchClausesData>) => queryOptions<SearchSearchClausesResponse, SearchSearchClausesError, SearchSearchClausesResponse, ReturnType<typeof searchSearchClausesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await searchSearchClauses({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: searchSearchClausesQueryKey(options)
});

export const searchGetOmniboxQueryKey = (options: Options<SearchGetOmniboxData>) => createQueryKey('searchGetOmnibox', options);

/**
 * Get Omnibox
 */
export const searchGetOmniboxOptions = (options: Options<SearchGetOmniboxData>) => queryOptions<SearchGetOmniboxResponse, SearchGetOmniboxError, SearchGetOmniboxResponse, ReturnType<typeof searchGetOmniboxQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await searchGetOmnibox({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: searchGetOmniboxQueryKey(options)
});

export const operationsListSourcesQueryKey = (options?: Options<OperationsListSourcesData>) => createQueryKey('operationsListSources', options);

/**
 * List Sources
 */
export const operationsListSourcesOptions = (options?: Options<OperationsListSourcesData>) => queryOptions<OperationsListSourcesResponse, OperationsListSourcesError, OperationsListSourcesResponse, ReturnType<typeof operationsListSourcesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await operationsListSources({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: operationsListSourcesQueryKey(options)
});

export const operationsGetSourceWatchQueryKey = (options: Options<OperationsGetSourceWatchData>) => createQueryKey('operationsGetSourceWatch', options);

/**
 * Get Source Watch
 */
export const operationsGetSourceWatchOptions = (options: Options<OperationsGetSourceWatchData>) => queryOptions<OperationsGetSourceWatchResponse, OperationsGetSourceWatchError, OperationsGetSourceWatchResponse, ReturnType<typeof operationsGetSourceWatchQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await operationsGetSourceWatch({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: operationsGetSourceWatchQueryKey(options)
});

export const operationsGetSystemStatusQueryKey = (options?: Options<OperationsGetSystemStatusData>) => createQueryKey('operationsGetSystemStatus', options);

/**
 * Get System Status
 */
export const operationsGetSystemStatusOptions = (options?: Options<OperationsGetSystemStatusData>) => queryOptions<OperationsGetSystemStatusResponse, OperationsGetSystemStatusError, OperationsGetSystemStatusResponse, ReturnType<typeof operationsGetSystemStatusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await operationsGetSystemStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: operationsGetSystemStatusQueryKey(options)
});

export const lifecycleGetVersionDiffQueryKey = (options: Options<LifecycleGetVersionDiffData>) => createQueryKey('lifecycleGetVersionDiff', options);

/**
 * Get Version Diff
 */
export const lifecycleGetVersionDiffOptions = (options: Options<LifecycleGetVersionDiffData>) => queryOptions<LifecycleGetVersionDiffResponse, LifecycleGetVersionDiffError, LifecycleGetVersionDiffResponse, ReturnType<typeof lifecycleGetVersionDiffQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await lifecycleGetVersionDiff({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: lifecycleGetVersionDiffQueryKey(options)
});

export const lifecycleGetClauseContextDiffQueryKey = (options: Options<LifecycleGetClauseContextDiffData>) => createQueryKey('lifecycleGetClauseContextDiff', options);

/**
 * Get Clause Context Diff
 */
export const lifecycleGetClauseContextDiffOptions = (options: Options<LifecycleGetClauseContextDiffData>) => queryOptions<LifecycleGetClauseContextDiffResponse, LifecycleGetClauseContextDiffError, LifecycleGetClauseContextDiffResponse, ReturnType<typeof lifecycleGetClauseContextDiffQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await lifecycleGetClauseContextDiff({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: lifecycleGetClauseContextDiffQueryKey(options)
});

export const metaGetHealthQueryKey = (options?: Options<MetaGetHealthData>) => createQueryKey('metaGetHealth', options);

/**
 * Get Health
 */
export const metaGetHealthOptions = (options?: Options<MetaGetHealthData>) => queryOptions<MetaGetHealthResponse, MetaGetHealthError, MetaGetHealthResponse, ReturnType<typeof metaGetHealthQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await metaGetHealth({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: metaGetHealthQueryKey(options)
});

export const metaGetReadinessQueryKey = (options?: Options<MetaGetReadinessData>) => createQueryKey('metaGetReadiness', options);

/**
 * Get Readiness
 */
export const metaGetReadinessOptions = (options?: Options<MetaGetReadinessData>) => queryOptions<MetaGetReadinessResponse, MetaGetReadinessError, MetaGetReadinessResponse, ReturnType<typeof metaGetReadinessQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await metaGetReadiness({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: metaGetReadinessQueryKey(options)
});
